import React, { useState, useEffect, useRef } from 'react';
import { Sparkles, ChevronDown, ChevronRight, Plus, Search, SortAsc, SortDesc } from 'lucide-react';
//  toggle functionality
import { ChevronUp, EyeOff, Eye } from 'lucide-react';
import Header from './Header';
import { getUserInfo } from './apiUtils';
import ManageRequirementExceptions from './ManageRequirementExceptions';
import CreateExceptionDialog from './CreateExceptionDialog';
import UpdateClassificationDialog from './UpdateClassificationDialog';
import { Upload, X, PaperclipIcon, Trash2, Download } from 'lucide-react';
import CopyRequirementDialog from './CopyRequirementDialog';
import ManageApproversDialog from './ManageApproversDialog';
import ApproveRequirementsDialog from './ApproveRequirementsDialog';
import ManageUseCasesDialog from './ManageUseCasesDialog';
import ManageCommentsDialog from './ManageCommentsDialog';
import { useLocation, useSearchParams } from 'react-router-dom';
import { Calendar, Filter } from 'lucide-react';
import ManageLinksDialog from './ManageLinksDialog';
import AIRequirementsDialog from './AIRequirementsDialog';
import { validateFiles, formatFileSize, MAX_FILE_SIZE, ALLOWED_EXTENSIONS } from './fileValidationUtils';
import AddApproverDialog from './AddApproverDialog';



// Import the JSON-based configuration
import appConfig, { ENDPOINT_KEYS } from './config/appConfig';





  const styles = {
    deleteButton: {
      backgroundColor: '#dc3545',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      padding: '6px 12px',
      height: '28px',
      fontSize: '0.8rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    editButton: {
      backgroundColor: '#4CAF50',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      padding: '6px 12px',
      height: '28px',
      fontSize: '0.8rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    disabled: {
      opacity: 0.6
    },
    container: {
      padding: '20px',
      maxWidth: '1200px',
      margin: '0 auto',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      marginTop: '0px',
      backgroundColor: '#fff',
      boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
      fontSize: '0.875rem',
    },
    th: {
      backgroundColor: '#E5E4E2',
      color: '#0064e5',
      padding: '6px 12px',
      textAlign: 'left',
      borderBottom: '2px solid #ddd',
      fontSize: '0.875rem',
      lineHeight: '1',
      height: '32px',
      cursor: 'pointer', // Add this to indicate it's clickable
      userSelect: 'none', // Prevent text selection when clicking
      position: 'relative' // For positioning the sort icons

    },
    td: {
      padding: '12px',
      borderBottom: '1px solid #ddd',
    },
    checkbox: {
      marginRight: '10px',
    },
    button: {
      padding: '6px 12px',
      margin: '0 5px',
      backgroundColor: '#007bff',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '0.8rem',
      height: '28px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    error: {
      color: 'red',
      padding: '10px',
      marginBottom: '10px',
    },
  };

const DialogStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  },
  dialog: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    width: '700px',
    maxWidth: '90vw',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    maxHeight: '90vh',
    overflowY: 'auto'
  }
};

const AttachmentList = ({ attachments, onDelete, onDownload, isLoading }) => {
  if (isLoading) {
    return <div className="mt-2 text-sm text-gray-500">Loading attachments...</div>;
  }

  if (!attachments || attachments.length === 0) {
    return <div className="mt-2 text-sm text-gray-500">No attachments</div>;
  }

  return (
    <div className="mt-2 space-y-2">
      {attachments.map(attachment => (
        <div
          key={attachment.attachment_id}
          className="flex items-center justify-between p-2 bg-gray-50 rounded border"
        >
          <div className="flex items-center">
            <PaperclipIcon className="h-4 w-4 mr-2 text-gray-500" />
            <span className="text-sm truncate mr-2 max-w-xs">{attachment.file_name}</span>
            <span className="text-xs text-gray-500">
              ({formatFileSize(attachment.file_size)})
            </span>
          </div>
          <div className="flex space-x-2">
            <button
              type="button"
              onClick={() => onDownload(attachment.attachment_id)}
              className="p-1 text-blue-600 hover:text-blue-800 rounded"
            >
              <Download className="h-4 w-4" />
            </button>
            <button
              type="button"
              onClick={() => onDelete(attachment.attachment_id)}
              className="p-1 text-red-600 hover:text-red-800 rounded"
            >
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};






const Dialog = ({ message, onClose, onCancel }) => {
  const isConfirmation = message.startsWith('Are you sure');
   console.log('Dialog message - inside Dialog:', message);
  return (
    <div style={DialogStyles.overlay}>
      <div style={DialogStyles.dialog}>
<h2
  className="text-lg font-semibold mb-4"
  style={{ whiteSpace: 'pre-line' }}
>
  {message}
</h2>
        <div className="flex justify-end gap-4">
          {isConfirmation ? (
            <>
              <button
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                onClick={onClose}
              >
                Yes
              </button>
              <button
                className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
                onClick={onCancel}
              >
                No
              </button>
            </>
          ) : (
            <button
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              onClick={onClose}
            >
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
};






const UpdateStatusDialog = ({ isOpen, onClose, onSubmit, selectedIds, availableStatuses }) => {
  const [selectedStatus, setSelectedStatus] = useState('');
  const [error, setError] = useState('');
  const statusInputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setSelectedStatus('');
      setError('');
    }
  }, [isOpen]);

  // Focus input when dialog opens
  useEffect(() => {
    if (isOpen && statusInputRef.current) {
      statusInputRef.current.focus();
    }
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedStatus) {
      setError('Status updated successfully');

      // Delay the update to show success message
      setTimeout(() => {
        onSubmit(selectedStatus);
      }, 2000);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={DialogStyles.overlay}>
      <div style={{...DialogStyles.dialog, width: '500px'}}>
        <h2 style={{
          backgroundColor: '#CCCCFF',
          textAlign: 'center',
          padding: '10px',
          margin: '-20px -20px 20px -20px',
          borderRadius: '8px 8px 0 0',
          fontSize: '18px',
          fontWeight: 'bold'
        }}>
          Update Requirement Status
        </h2>
        <form onSubmit={handleSubmit}>
          <div style={{marginBottom: '15px'}}>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>New Status*:</label>
            <select
              ref={statusInputRef}
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '14px'
              }}
              required
            >
              <option value="">Select a status</option>
              {availableStatuses.map(status => (
                <option key={status} value={status}>{status}</option>
              ))}
            </select>
          </div>
          {error && (
            <div style={{
              marginBottom: '15px',
              padding: '8px',
              borderRadius: '4px',
              backgroundColor: error.includes('successfully') ? '#f0f9ff' : '#fef2f2',
              color: error.includes('successfully') ? '#059669' : '#dc2626',
              border: error.includes('successfully') ? '1px solid #10b981' : '1px solid #ef4444'
            }}>
              {error}
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                backgroundColor: '#FFFDD0',
                padding: '8px 16px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Close
            </button>
            <button
              type="submit"
              style={{
                padding: '8px 16px',
                backgroundColor: '#C8F4DE',
                color: 'black',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px',
                opacity: !selectedStatus ? 0.5 : 1
              }}
              disabled={!selectedStatus}
            >
              Update Status
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};


// New UpdateCriticalityDialog component
const UpdateCriticalityDialog = ({ isOpen, onClose, onSubmit, selectedIds, availableCriticalities }) => {
  const [selectedCriticality, setSelectedCriticality] = useState('');
  const [error, setError] = useState('');
  const criticalityInputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setSelectedCriticality('');
      setError('');
    }
  }, [isOpen]);

  // Focus input when dialog opens
  useEffect(() => {
    if (isOpen && criticalityInputRef.current) {
      criticalityInputRef.current.focus();
    }
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedCriticality) {
      setError('Criticality updated successfully');

      // Delay the update to show success message
      setTimeout(() => {
        onSubmit(selectedCriticality);
      }, 2000);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={DialogStyles.overlay}>
      <div style={{...DialogStyles.dialog, width: '500px'}}>
        <h2 style={{
          backgroundColor: '#CCCCFF',
          textAlign: 'center',
          padding: '10px',
          margin: '-20px -20px 20px -20px',
          borderRadius: '8px 8px 0 0',
          fontSize: '18px',
          fontWeight: 'bold'
        }}>
          Update Requirement Criticality
        </h2>
        <form onSubmit={handleSubmit}>
          <div style={{marginBottom: '15px'}}>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>New Criticality*:</label>
            <select
              ref={criticalityInputRef}
              value={selectedCriticality}
              onChange={(e) => setSelectedCriticality(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '14px'
              }}
              required
            >
              <option value="">Select a criticality level</option>
              {availableCriticalities.map(criticality => (
                <option key={criticality} value={criticality}>{criticality}</option>
              ))}
            </select>
          </div>
          {error && (
            <div style={{
              marginBottom: '15px',
              padding: '8px',
              borderRadius: '4px',
              backgroundColor: error.includes('successfully') ? '#f0f9ff' : '#fef2f2',
              color: error.includes('successfully') ? '#059669' : '#dc2626',
              border: error.includes('successfully') ? '1px solid #10b981' : '1px solid #ef4444'
            }}>
              {error}
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                backgroundColor: '#FFFDD0',
                padding: '8px 16px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Close
            </button>
            <button
              type="submit"
              style={{
                padding: '8px 16px',
                backgroundColor: '#C8F4DE',
                color: 'black',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px',
                opacity: !selectedCriticality ? 0.5 : 1
              }}
              disabled={!selectedCriticality}
            >
              Update Criticality
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};






const UpdatePriorityDialog = ({ isOpen, onClose, onSubmit, selectedIds, availablePriorities }) => {
  const [selectedPriority, setSelectedPriority] = useState('');
  const [error, setError] = useState('');
  const priorityInputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setSelectedPriority('');
      setError('');
    }
  }, [isOpen]);

  // Focus input when dialog opens
  useEffect(() => {
    if (isOpen && priorityInputRef.current) {
      priorityInputRef.current.focus();
    }
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedPriority) {
      setError('Priority updated successfully');

      // Delay the update to show success message
      setTimeout(() => {
        onSubmit(selectedPriority);
      }, 2000);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={DialogStyles.overlay}>
      <div style={{...DialogStyles.dialog, width: '500px'}}>
        <h2 style={{
          backgroundColor: '#CCCCFF',
          textAlign: 'center',
          padding: '10px',
          margin: '-20px -20px 20px -20px',
          borderRadius: '8px 8px 0 0',
          fontSize: '18px',
          fontWeight: 'bold'
        }}>
          Update Requirement Priority
        </h2>
        <form onSubmit={handleSubmit}>
          <div style={{marginBottom: '15px'}}>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>New Priority*:</label>
            <select
              ref={priorityInputRef}
              value={selectedPriority}
              onChange={(e) => setSelectedPriority(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '14px'
              }}
              required
            >
              <option value="">Select a priority level</option>
              {availablePriorities.map(priority => (
                <option key={priority} value={priority}>{priority}</option>
              ))}
            </select>
          </div>
          {error && (
            <div style={{
              marginBottom: '15px',
              padding: '8px',
              borderRadius: '4px',
              backgroundColor: error.includes('successfully') ? '#f0f9ff' : '#fef2f2',
              color: error.includes('successfully') ? '#059669' : '#dc2626',
              border: error.includes('successfully') ? '1px solid #10b981' : '1px solid #ef4444'
            }}>
              {error}
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                backgroundColor: '#FFFDD0',
                padding: '8px 16px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Close
            </button>
            <button
              type="submit"
              style={{
                padding: '8px 16px',
                backgroundColor: '#C8F4DE',
                color: 'black',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px',
                opacity: !selectedPriority ? 0.5 : 1
              }}
              disabled={!selectedPriority}
            >
              Update Priority
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};




// Updated CreateRequirementDialog component with improved layout and color sections
const CreateRequirementDialog = ({
  isOpen,
  onClose,
  onSubmit,
  levelId,
  isEditMode,
  requirementToEdit,
  currentProject,
  corporateAccount,
  login_token,
  availableStatuses,
  functionalLevelPath,
  availableCriticalities,
  availablePriorities,
  permissions,
  onOpenManageApprovers,
  reqIdFromUrl
}) => {
  const [description, setDescription] = useState('');
  const [status, setStatus] = useState('Created');
  const [criticality, setCriticality] = useState('');
  const [priority, setPriority] = useState('');
  const [error, setError] = useState('');
  const textareaRef = useRef(null);

  // Success state management
  const [createSuccess, setCreateSuccess] = useState(null);
  const [showValidationErrors, setShowValidationErrors] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [refField1, setRefField1] = useState('');
  const [refField2, setRefField2] = useState('');
  const [refField3, setRefField3] = useState('');
  const [refField4, setRefField4] = useState('');

  // State for attachments
  const [files, setFiles] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [isLoadingAttachments, setIsLoadingAttachments] = useState(false);
  const fileInputRef = useRef(null);

const [attachmentUploadFailed, setAttachmentUploadFailed] = useState(false);


  // Updated dialog styles with fixed layout
  const dialogStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '20px'
    },
    dialog: {
      backgroundColor: 'white',
      borderRadius: '8px',
      width: '700px',
      maxWidth: '90vw',
      height: '90vh',
      maxHeight: '90vh',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    },
    header: {
      backgroundColor: '#CCCCFF',
      textAlign: 'center',
      padding: '10px 20px',
      borderRadius: '8px 8px 0 0',
      fontSize: '18px',
      fontWeight: 'bold',
      flexShrink: 0
    },
    content: {
      flex: 1,
      overflowY: 'auto',
      padding: '20px',
      maxHeight: 'calc(90vh - 120px)'
    },
    footer: {
      padding: '15px 20px',
      borderTop: '1px solid #e5e7eb',
      backgroundColor: '#f9fafb',
      borderRadius: '0 0 8px 8px',
      flexShrink: 0
    }
  };

  useEffect(() => {
    if (isOpen && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [isOpen]);

  // Reset success state when dialog opens
  useEffect(() => {
    if (isOpen) {
      setCreateSuccess(null);
      setShowValidationErrors(false);
      setError('');
    }
  }, [isOpen]);

  useEffect(() => {
    if (isEditMode && requirementToEdit) {
      setDescription(requirementToEdit.req_description);
      setStatus(requirementToEdit.status);

      // Set reference fields
      setRefField1(requirementToEdit.ref_field_1 || '');
      setRefField2(requirementToEdit.ref_field_2 || '');
      setRefField3(requirementToEdit.ref_field_3 || '');
      setRefField4(requirementToEdit.ref_field_4 || '');

      // Handle criticality
      if (requirementToEdit.criticality !== undefined) {
        setCriticality(requirementToEdit.criticality);
      } else if (requirementToEdit.req_criticality !== undefined) {
        setCriticality(requirementToEdit.req_criticality);
      } else {
        setCriticality(availableCriticalities && availableCriticalities.length > 0 ?
          availableCriticalities[0] : '');
      }

      // Handle priority
      if (requirementToEdit.priority !== undefined) {
        setPriority(requirementToEdit.priority);
      } else if (requirementToEdit.req_priority !== undefined) {
        setPriority(requirementToEdit.req_priority);
      } else {
        setPriority(availablePriorities && availablePriorities.length > 0 ?
          availablePriorities[0] : '');
      }

      // Fetch attachments for this requirement
      fetchAttachments(requirementToEdit.req_id_with_prefix);
    } else  if (!isEditMode)  {
      setDescription('');
      setRefField1('');
      setRefField2('');
      setRefField3('');
      setRefField4('');
      setFiles([]);
      setAttachments([]);
      setAttachmentUploadFailed(false); // Reset attachment upload failed state

      // Only set default status when initially opening the dialog
      if (isOpen) {
        setStatus('Created');
        setCriticality('');
        setPriority('');
      }
    }
  }, [isEditMode, requirementToEdit, isOpen, availableCriticalities, availablePriorities]);



const handleCreateNew = () => {
  // Reset all form fields to initial state
  setDescription('');
  setStatus('Created');
  setCriticality('');
  setPriority('');
  setRefField1('');
  setRefField2('');
  setRefField3('');
  setRefField4('');
  setFiles([]);
  setAttachments([]);
  setError('');
  setCreateSuccess(null);
  setShowValidationErrors(false);
  setIsLoading(false);

  // Focus on the description field
  setTimeout(() => {
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  }, 100);
};


  // Updated handleSubmit function
  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    }

    setShowValidationErrors(true);
    setError('');
    setIsLoading(true);

    if (!levelId) {
      setError('Please select a functional level before creating a requirement');
      setIsLoading(false);
      return { success: false };
    }

    // Validation checks
    if (!description.trim()) {
      setError('Description is required');
      setIsLoading(false);
      return { success: false };
    }

    if (!criticality) {
      setError('Criticality is required');
      setIsLoading(false);
      return { success: false };
    }

    const endpoint = isEditMode ?
      appConfig.getUrl('/update_requirement'):
      appConfig.getUrl('/create_requirement');

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${login_token}`
        },
        body: JSON.stringify({
          corporate_account: corporateAccount,
          project_id: currentProject,
          level_id: levelId,
          req_description: description,
          status: status,
          req_criticality: criticality,
          req_priority: priority,
          ref_field_1: refField1,
          ref_field_2: refField2,
          ref_field_3: refField3,
          ref_field_4: refField4,
          ...(isEditMode && { req_id: requirementToEdit.req_id })
        })
      });

      const data = await response.json();

       console.log('create requirement response ', data)








    if (data.status === 'Success') {
  // Handle file uploads if there are any
  if (files.length > 0) {
    console.log('Check 1')
    console.log('ATTACHMENT requirementToEdit.req_id_with_prefix', requirementToEdit?.req_id_with_prefix);
    console.log('Check 2')
    console.log('ATTACHMENT data.req_id_with_prefix ', data.req_id_with_prefix);
    console.log('Check 3')
    const reqId = isEditMode ? requirementToEdit?.req_id_with_prefix : data.req_id_with_prefix;
    console.log('Check 4')
    console.log('ATTACHMENT requirementToEdit.req_id', requirementToEdit?.req_id )
    console.log('Check 5')
    console.log('ATTACHMENT data.req_id ', data.req_id )
    console.log('Check 6')

    const uploadSuccess = await uploadAttachments(reqId);

    if (!uploadSuccess) {
      setAttachmentUploadFailed(true);

      // Show success message for requirement creation but indicate attachment failure
//      setError(`Requirement ${isEditMode ? 'updated' : 'created'} successfully, but attachment upload failed. Please close this dialog and edit the requirement to retry uploading attachments.`);

      console.log('Requirement saved successfully but attachment failed:', data);

      // Still set success state to trigger list refresh when dialog closes
      setTimeout(() => {
        setCreateSuccess({
          success: true,
          isEditMode: isEditMode,
          reqId: data.req_id,
          reqIdWithPrefix: data.req_id_with_prefix,
          attachmentCount: 0 // No attachments were uploaded
        });
      }, 10);

      setIsLoading(false);
      return {
        success: true, // Return success true to trigger list refresh
        isEditMode: isEditMode,
        reqId: data.req_id,
        reqIdWithPrefix: data.req_id_with_prefix,
        attachmentFailed: true // Optional flag to indicate attachment failure
      };
    }
  }
  // Show success message first (only when everything succeeds)
  setError(`Requirement ${isEditMode ? 'updated' : 'created'} successfully`);

  // Delay the success state to show success message
  setTimeout(() => {
    setCreateSuccess({
      success: true,
      isEditMode: isEditMode,
      reqId: data.req_id,
      reqIdWithPrefix: data.req_id_with_prefix,
      attachmentCount: files.length
    });
  }, 10);

  return {
    success: true,
    isEditMode: isEditMode,
    reqId: data.req_id,
    reqIdWithPrefix: data.req_id_with_prefix
  };
}












      else {
        throw new Error(data.status_description || 'Failed to save requirement');
      }
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
      return { success: false };
    } finally {
      setIsLoading(false);
    }
  };

  // ... (all the attachment-related functions remain the same) ...
  const fetchAttachments = async (reqId) => {
    if (!reqId) return;

    setIsLoadingAttachments(true);
    try {
      const response = await fetch(appConfig.getUrl('/get_requirement_attachments'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${login_token}`
        },
        body: JSON.stringify({
          corporate_account: corporateAccount,
          project_id: currentProject,
          req_id: reqId
        })
      });

      const data = await response.json();
      if (data.status === 'Success') {
        setAttachments(data.attachments);
      } else {
        console.error('Failed to fetch attachments:', data.status_description);
      }
    } catch (error) {
      console.error('Error fetching attachments:', error);
    } finally {
      setIsLoadingAttachments(false);
    }
  };

const handleFileChange = (e) => {
  const selectedFiles = Array.from(e.target.files);

  const validationResult = validateFiles(selectedFiles);
  if (!validationResult.isValid) {
    setError(`File validation failed: ${validationResult.errors.join('; ')}`);
    e.target.value = ''; // Clear the file input
    return;
  }

  setError(''); // Clear any previous errors
  setFiles(prevFiles => [...prevFiles, ...selectedFiles]);
};

  const removeFile = (index) => {
    setFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
  };

  const handleDeleteAttachment = async (attachmentId) => {
    try {
      const response = await fetch(appConfig.getUrl('/delete_requirement_attachment'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${login_token}`
        },
        body: JSON.stringify({
          corporate_account: corporateAccount,
          project_id: currentProject,
          attachment_id: attachmentId
        })
      });

      const data = await response.json();
      if (data.status === 'Success') {
        setAttachments(prevAttachments =>
          prevAttachments.filter(attachment => attachment.attachment_id !== attachmentId)
        );
      } else {
        setError(`Failed to delete attachment: ${data.status_description}`);
      }
    } catch (error) {
      setError(`Error deleting attachment: ${error.message}`);
    }
  };

  const handleDownloadAttachment = (attachmentId) => {

    const downloadUrl = appConfig.getUrl(`/download_requirement_attachment/${attachmentId}`);

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = downloadUrl;
    form.target = '_blank';

    const tokenInput = document.createElement('input');
    tokenInput.type = 'hidden';
    tokenInput.name = 'token';
    tokenInput.value = login_token;
    form.appendChild(tokenInput);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };


  const validationResult = validateFiles(files);
  if (!validationResult.isValid) {
    setError(`File validation failed: ${validationResult.errors.join(', ')}`);
    return false;
  }



const uploadAttachments = async (reqId) => {
  if (files.length === 0) return true;

  // Add file validation before upload
  const validationResult = validateFiles(files);
  if (!validationResult.isValid) {
    setError(`File validation failed: ${validationResult.errors.join(', ')}`);
    return false;
  }

  setIsUploading(true);

  const formData = new FormData();
  formData.append('req_id', reqId);
  formData.append('corporate_account', corporateAccount);
  formData.append('project_id', currentProject);
  formData.append('user_id', localStorage.getItem('user_id') || '');

  files.forEach(file => {
    formData.append('files[]', file);
  });

  try {
    const response = await fetch(appConfig.getUrl('/upload_requirement_attachment'), {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${login_token}`
      },
      body: formData
    });

    const data = await response.json();

//    // Enhanced error handling for 413 errors
//    if (response.status === 413) {
//      throw new Error('File too large. Maximum file size allowed is 10MB');
//    }

    if (data.status === 'Success') {
      setFiles([]);
      if (isEditMode) {
        fetchAttachments(reqId);
      }
      return true;
    } else {
      throw new Error(data.errors || 'Failed to upload attachments');
    }
  } catch (error) {
    console.error('Upload error:', error);

if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
  setError('Network error: Please check your internet connection and try again. Please close this dialog and edit the requirement to retry uploading attachments.');
} else if (error.message.includes('413') || error.message.includes('too large')) {
  setError('Requirement saved, but file not attached. Please reduce file size and try again (Maximum: 10MB per file). Please close this dialog and edit the requirement to retry uploading attachments.');
} else {
  setError(`Error uploading attachments: ${error.message}. Please close this dialog and edit the requirement to retry uploading attachments.`);
}


    return false;
  } finally {
    setIsUploading(false);
  }
};



  if (!isOpen) return null;

  return (
    <div style={dialogStyles.overlay}>
      <div style={dialogStyles.dialog}>
        {/* Fixed Header */}
            <div style={dialogStyles.header}>
              {isEditMode ? `Edit Requirement ${
                requirementToEdit?.req_id_with_prefix ||
                reqIdFromUrl ||
                ''
              }` : 'Create New Requirement'}
            </div>


        {/* Scrollable Content */}
        <div style={dialogStyles.content}>
          {createSuccess ? (
            <div className="mb-4">
              <div style={{
                marginBottom: '15px',
                padding: '12px',
                borderRadius: '4px',
                backgroundColor: '#f0f9ff',
                color: '#059669',
                border: '1px solid #10b981'
              }}>
                <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                  Requirement successfully {createSuccess.isEditMode ? 'updated' : 'created'}!
                </p>
                <p style={{ marginBottom: '4px' }}>
                  Requirement ID: <span style={{ fontWeight: 'bold' }}>
                    {createSuccess.reqIdWithPrefix}
                  </span>
                </p>
                {createSuccess.attachmentCount > 0 && (
                  <p style={{ margin: '0' }}>
                    {createSuccess.attachmentCount} attachment{createSuccess.attachmentCount !== 1 ? 's' : ''} uploaded
                  </p>
                )}
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <div style={{ flex: 1 }}>
                {/* ===== BASIC INFORMATION SECTION ===== */}
                <div style={{
                  backgroundColor: '#f0f9ff',
                  border: '1px solid #e0f2fe',
                  borderRadius: '8px',
                  padding: '16px',
                  marginBottom: '20px'
                }}>
                  <h3 style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    marginBottom: '16px',
                    color: '#0284c7',
                    borderBottom: '2px solid #0284c7',
                    paddingBottom: '4px'
                  }}>
                    📋 Basic Information
                  </h3>

                  {/* Functional Level */}
                  <div style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                      Functional Level:
                    </label>
                    <input
                      type="text"
                      value={functionalLevelPath || 'Not selected'}
                      style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        backgroundColor: '#f9fafb',
                        fontSize: '14px'
                      }}
                      disabled
                    />
                  </div>

                  {/* Requirement Description */}
                  <div style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                      Requirement Description: <span style={{ color: '#dc2626' }}>*</span>
                    </label>
                    <textarea
                      ref={textareaRef}
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '8px',
                        border: `1px solid ${showValidationErrors && !description.trim() ? '#dc2626' : '#ddd'}`,
                        borderRadius: '4px',
                        fontSize: '14px',
                        resize: 'vertical'
                      }}
                      rows={4}
                      required
                    />
                    {showValidationErrors && !description.trim() && (
                      <span style={{ color: '#dc2626', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                        Description is required
                      </span>
                    )}
                  </div>
                </div>

                {/* ===== STATUS & PRIORITY SECTION ===== */}
                <div style={{
                  backgroundColor: '#faf5ff',
                  border: '1px solid #f3e8ff',
                  borderRadius: '8px',
                  padding: '16px',
                  marginBottom: '20px'
                }}>
                  <h3 style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    marginBottom: '16px',
                    color: '#9333ea',
                    borderBottom: '2px solid #9333ea',
                    paddingBottom: '4px'
                  }}>
                    ⚡ Status & Priority
                  </h3>

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px' }}>
                    {/* Status */}
                    <div>
                      <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                        Status: <span style={{ color: '#dc2626' }}>*</span>
                      </label>
                      <select
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '8px',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          fontSize: '14px'
                        }}
                        required
                      >
                        {availableStatuses.map(statusOption => (
                          <option key={statusOption} value={statusOption}>
                            {statusOption}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Criticality */}
                    <div>
                      <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                        Criticality: <span style={{ color: '#dc2626' }}>*</span>
                      </label>
                      <select
                        value={criticality}
                        onChange={(e) => setCriticality(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '8px',
                          border: `1px solid ${showValidationErrors && !criticality ? '#dc2626' : '#ddd'}`,
                          borderRadius: '4px',
                          fontSize: '14px'
                        }}
                        required
                      >
                        <option value="">Select criticality</option>
                        {availableCriticalities && availableCriticalities.map(criticalityOption => (
                          <option key={criticalityOption} value={criticalityOption}>
                            {criticalityOption}
                          </option>
                        ))}
                      </select>
                      {showValidationErrors && !criticality && (
                        <span style={{ color: '#dc2626', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                          Criticality is required
                        </span>
                      )}
                      {isEditMode && !criticality && availableCriticalities && availableCriticalities.length > 0 && (
                        <p style={{ marginTop: '4px', color: '#d97706', fontSize: '12px' }}>
                          No criticality value found for this requirement. Please select one.
                        </p>
                      )}
                    </div>

                    {/* Priority */}
                    <div>
                      <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                        Priority:
                      </label>
                      <select
                        value={priority}
                        onChange={(e) => setPriority(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '8px',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          fontSize: '14px'
                        }}
                      >
                        <option value="">Select priority</option>
                        {availablePriorities && availablePriorities.map(priorityOption => (
                          <option key={priorityOption} value={priorityOption}>
                            {priorityOption}
                          </option>
                        ))}
                      </select>
                      {isEditMode && !priority && availablePriorities && availablePriorities.length > 0 && (
                        <p style={{ marginTop: '4px', color: '#d97706', fontSize: '12px' }}>
                          No priority value found for this requirement. Please select one.
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                {/* ===== REFERENCE FIELDS SECTION ===== */}
                <div style={{
                  backgroundColor: '#fffbeb',
                  border: '1px solid #fef3c7',
                  borderRadius: '8px',
                  padding: '16px',
                  marginBottom: '20px'
                }}>
                  <h3 style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    marginBottom: '16px',
                    color: '#d97706',
                    borderBottom: '2px solid #d97706',
                    paddingBottom: '4px'
                  }}>
                    🔗 Reference Fields
                  </h3>

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                    <div>
                      <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                        Reference Field 1:
                      </label>
                      <input
                        type="text"
                        value={refField1}
                        onChange={(e) => setRefField1(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '8px',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          fontSize: '14px'
                        }}
                        maxLength={100}
                      />
                    </div>

                    <div>
                      <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                        Reference Field 2:
                      </label>
                      <input
                        type="text"
                        value={refField2}
                        onChange={(e) => setRefField2(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '8px',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          fontSize: '14px'
                        }}
                        maxLength={100}
                      />
                    </div>

                    <div>
                      <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                        Reference Field 3:
                      </label>
                      <input
                        type="text"
                        value={refField3}
                        onChange={(e) => setRefField3(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '8px',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          fontSize: '14px'
                        }}
                        maxLength={100}
                      />
                    </div>

                    <div>
                      <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                        Reference Field 4:
                      </label>
                      <input
                        type="text"
                        value={refField4}
                        onChange={(e) => setRefField4(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '8px',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          fontSize: '14px'
                        }}
                        maxLength={100}
                      />
                    </div>
                  </div>
                </div>

                {/* ===== ATTACHMENTS SECTION ===== */}
                <div style={{
                  backgroundColor: '#faf5ff',
                  border: '1px solid #e9d5ff',
                  borderRadius: '8px',
                  padding: '16px',
                  marginBottom: '20px'
                }}>
                  <h3 style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    marginBottom: '16px',
                    color: '#a855f7',
                    borderBottom: '2px solid #a855f7',
                    paddingBottom: '4px'
                  }}>
                    📎 Attachments
                  </h3>

                  {/* Existing Attachments */}
                  {isEditMode && (
                    <div style={{ marginBottom: '15px' }}>
                      <h4 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '8px', color: '#7c3aed' }}>
                        Current Attachments:
                      </h4>
                      <AttachmentList
                        attachments={attachments}
                        onDelete={handleDeleteAttachment}
                        onDownload={handleDownloadAttachment}
                        isLoading={isLoadingAttachments}
                      />
                    </div>
                  )}

                  {/* File Upload */}
                  <div style={{ marginBottom: '8px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold', color: '#7c3aed' }}>
                        Upload New Attachments:
                      </label>
                      <button
                        type="button"
                        onClick={() => fileInputRef.current?.click()}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '12px',
                          color: '#3b82f6',
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          textDecoration: 'underline'
                        }}
                      >
                        <Upload className="h-4 w-4 mr-1" />
                        Select Files
                      </button>
                    </div>

                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                      multiple
                    />

                    {/* Selected Files List */}
                    {files.length > 0 && (
                      <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {files.map((file, index) => (
                          <div
                            key={index}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              padding: '8px',
                              backgroundColor: '#dbeafe',
                              borderRadius: '4px',
                              border: '1px solid #93c5fd'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <PaperclipIcon className="h-4 w-4 mr-2" style={{ color: '#3b82f6' }} />
                              <span style={{ fontSize: '12px', marginRight: '8px', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{file.name}</span>
                              <span style={{ fontSize: '10px', color: '#6b7280' }}>
                                ({formatFileSize(file.size)})
                              </span>
                            </div>
                            <button
                              type="button"
                              onClick={() => removeFile(index)}
                              style={{
                                padding: '4px',
                                color: '#dc2626',
                                background: 'none',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                              }}
                            >
                              <X className="h-4 w-4" />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}

                    <p style={{ marginTop: '4px', fontSize: '10px', color: '#6b7280' }}>
                      Supported file types: PDF, DOC, DOCX, XLS, XLSX, TXT, PNG, JPG, JPEG, GIF
                    </p>
                  </div>
                </div>

                {/* ===== AUDIT INFORMATION SECTION ===== */}
                {isEditMode && requirementToEdit && (
                  <div style={{
                    backgroundColor: '#f9fafb',
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    padding: '16px',
                    marginBottom: '20px'
                  }}>
                    <h3 style={{
                      fontSize: '16px',
                      fontWeight: 'bold',
                      marginBottom: '16px',
                      color: '#6b7280',
                      borderBottom: '2px solid #6b7280',
                      paddingBottom: '4px'
                    }}>
                      📅 Audit Information
                    </h3>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                      {/* Creation Date */}
                      <div>
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                          Creation Date:
                        </label>
                        <input
                          type="text"
                          value={new Date(requirementToEdit.created_date).toLocaleString()}
                          style={{
                            width: '100%',
                            padding: '8px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            backgroundColor: '#f9fafb',
                            fontSize: '14px'
                          }}
                          disabled
                        />
                      </div>

                      {/* Last Updated Date */}
                      <div>
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                          Last Updated:
                        </label>
                        <input
                          type="text"
                          value={new Date(requirementToEdit.updated_date).toLocaleString()}
                          style={{
                            width: '100%',
                            padding: '8px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            backgroundColor: '#f9fafb',
                            fontSize: '14px'
                          }}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                )}


              </div>
            </form>
          )}
        </div>

        {/* Fixed Footer */}
        <div style={dialogStyles.footer}>



                       {/* Error message */}
                {error && (
                  <div style={{
                    marginBottom: '15px',
                    padding: '8px',
                    borderRadius: '4px',
                    backgroundColor: error.includes('successfully') ? '#f0f9ff' : '#fef2f2',
                    color: error.includes('successfully') ? '#059669' : '#dc2626',
                    border: error.includes('successfully') ? '1px solid #10b981' : '1px solid #ef4444'
                  }}>
                    {error}
                  </div>
                )}


          {createSuccess ? (




  <div style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>



    <button
      style={{
        padding: '8px 16px',
        backgroundColor: '#C8F4DE',
        color: 'black',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        minWidth: '120px'
      }}
      onClick={() => {
        onSubmit();
        onClose();
      }}
    >
      Close
    </button>






{/* NEW: Manage Approvers Button */}
    <button
      style={{
        padding: '8px 16px',
        backgroundColor: '#DBEAFE',
        color: '#1E40AF',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        minWidth: '120px'
      }}
      onClick={() => {
        // Close current dialog and open Manage Approvers
        onClose();
        // Trigger manage approvers - you'll need to pass this function down
        onOpenManageApprovers && onOpenManageApprovers(createSuccess.reqIdWithPrefix);
      }}
    >
      Manage Approvers
    </button>









        <button
        disabled={isEditMode || attachmentUploadFailed}
      style={{
        padding: '8px 16px',
        backgroundColor: '#DBEAFE',
        color: '#1E40AF',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        minWidth: '120px',
        opacity: isEditMode || attachmentUploadFailed ? 0.3 : 1
      }}
      onClick={handleCreateNew}
    >
     Create New
    </button>



  </div>






          ) : (
            <div style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
              <button
                type="button"
                onClick={onClose}
                style={{
                  backgroundColor: '#FFFDD0',
                  padding: '8px 16px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
                disabled={isLoading || isUploading}
              >
                Close
              </button>

<button
  type="submit"
  onClick={(e) => {
    // Check permissions before allowing submission
    if (!permissions.canUpdate) {
      e.preventDefault();
      setError('You do not have permission to create or edit requirements');
      return;
    }
    handleSubmit(e);
  }}
  style={{
    padding: '8px 16px',
    backgroundColor: !permissions.canUpdate ? '#f3f4f6' : '#C8F4DE',
    color: !permissions.canUpdate ? '#6b7280' : 'black',
    border: !permissions.canUpdate ? '1px solid #d1d5db' : 'none',
    borderRadius: '4px',
    fontSize: '14px',
    opacity: (isLoading || isUploading || (!isEditMode && attachmentUploadFailed) ) ? 0.3 : 1,
    display: 'flex',
    alignItems: 'center'
  }}
  disabled={isLoading || isUploading || (!isEditMode && attachmentUploadFailed)}
>
  {(isLoading || isUploading ) && (
    <svg style={{
      animation: 'spin 1s linear infinite',
      marginLeft: '-4px',
      marginRight: '8px',
      width: '16px',
      height: '16px'
    }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  )}
  {!permissions.canUpdate ?
    (isEditMode ? 'No Permission to Update' : 'No Permission to Create') :
    (isLoading ? 'Processing...' : isUploading ? 'Uploading...' : (isEditMode ? 'Update Requirement' : 'Create Requirement'))
  }
</button>



            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const BaseRequirementsManagement = () => {


  const [includeChildLevels, setIncludeChildLevels] = useState(false);

 const [functionalLevels, setFunctionalLevels] = useState([]);
  const [childLevels, setChildLevels] = useState({});
  const [selectedLevelId, setSelectedLevelId] = useState(null);
  const [expandedLevels, setExpandedLevels] = useState(new Set());
  const [requirements, setRequirements] = useState([]);
  const [selectedRequirements, setSelectedRequirements] = useState(new Set());
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
const [isAddApproverDialogOpen, setIsAddApproverDialogOpen] = useState(false);

    const [isCreateExceptionDialogOpen, setIsCreateExceptionDialogOpen] = useState(false);

  const [isClassificationDialogOpen, setIsClassificationDialogOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedRequirementForEdit, setSelectedRequirementForEdit] = useState(null);
  const [searchInput, setSearchInput] = useState('');
  const [searchFilter, setSearchFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [showDialog, setShowDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [permissions, setPermissions] = useState({
    canUpdate: false,
    canUpdateStatus: false,
    canUpdatePriority: false,
    canUpdateCriticality: false,
    canCopy: false,
    canApprove: false,
    canUpdateClassification: false,
    canCreateException: false,
    canDeleteException: false
  });

  const [availableCriticalities, setAvailableCriticalities] = useState([]);
  const [availablePriorities, setAvailablePriorities] = useState([]); // New state for priority options
  const [isKeyAttributesDialogOpen, setIsKeyAttributesDialogOpen] = useState(false);
  const [exceptionLevel, setExceptionLevel] = useState('Requirement');

  const [isCopyDialogOpen, setIsCopyDialogOpen] = useState(false);
  const [selectedRequirementForCopy, setSelectedRequirementForCopy] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);

  const [availableStatuses, setAvailableStatuses] = useState([]);
  const [functionalLevelPath, setFunctionalLevelPath] = useState([]);
  const [isUpdateStatusDialogOpen, setIsUpdateStatusDialogOpen] = useState(false);
  const [isUpdateCriticalityDialogOpen, setIsUpdateCriticalityDialogOpen] = useState(false);
  const [isUpdatePriorityDialogOpen, setIsUpdatePriorityDialogOpen] = useState(false); // New state for update priority dialog

  const login_token = localStorage.getItem('authToken');
  const [corporateAccount, setCorporateAccount] = useState('');
  const [currentProject, setCurrentProject] = useState('');
  const [userId, setUserId] = useState('');
  const [accountDescription, setAccountDescription] = useState('');
  const [userName, setUserName] = useState('');
  const [redirectPath, setRedirectPath] = useState('');

  const [isManageApproversDialogOpen, setIsManageApproversDialogOpen] = useState(false);
  const [isApprovalDialogOpen, setIsApprovalDialogOpen] = useState(false);
  const [isManageCommentsDialogOpen, setIsManageCommentsDialogOpen] = useState(false);
  const [isManageUseCasesDialogOpen, setIsManageUseCasesDialogOpen] = useState(false);


const [productAccessLevels, setProductAccessLevels] = useState({});
const [classificationOptions, setClassificationOptions] = useState([]);
const [isUpdatingClassification, setIsUpdatingClassification] = useState(false);
const [classificationUpdateError, setClassificationUpdateError] = useState('');

  const [filterStatus, setFilterStatus] = useState([]);
const [isAIDialogOpen, setIsAIDialogOpen] = useState(false);

const [criticalityFilter, setCriticalityFilter] = useState([]);
const [priorityFilter, setPriorityFilter] = useState([]);
const [dateRangeFilter, setDateRangeFilter] = useState({
  startDate: '',
  endDate: ''
});
const [updatedDateRangeFilter, setUpdatedDateRangeFilter] = useState({
  startDate: '',
  endDate: ''
});


  const [searchParams] = useSearchParams();
  const reqIdFromUrl = searchParams.get('reqId');


const [isManageLinksDialogOpen, setIsManageLinksDialogOpen] = useState(false);

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;



const [createSuccess, setCreateSuccess] = useState(null);
// Product classification state
const [productList, setProductList] = useState([]);
const [selectedProducts, setSelectedProducts] = useState([]);

// toggle
const [showProductComparison, setShowProductComparison] = useState(false);
const [showFilters, setShowFilters] = useState(false);


const generateRequirementDirectLink = (reqId, projectId) => {
  const baseUrl = window.location.origin;
  const currentPath = '/BaseRequirementsManagement';
  return `${baseUrl}${currentPath}?project=${encodeURIComponent(projectId)}&reqId=${encodeURIComponent(reqId)}&action=edit`;
};



const handleManageUseCasesClick = () => {
  setIsManageUseCasesDialogOpen(true);
};

const handleApproveButtonClick = () => {
  setIsApprovalDialogOpen(true);
};

const handleManageApproversClick = () => {
  setIsManageApproversDialogOpen(true);
};

  const showErrorDialog = (message, path) => {
    setDialogMessage(message);
    setRedirectPath(path);
    setShowDialog(true);
  };

const handleManageLinksClick = () => {
  if (selectedRequirements.size !== 1) {
    setDialogMessage('Please select exactly one requirement to manage links');
    setShowDialog(true);
    return;
  }

  setIsManageLinksDialogOpen(true);
};






const handleCreateAIRequirements = async (generatedRequirements, defaultSettings) => {
  try {
    const createdRequirements = [];
    const failedRequirements = [];

    // Create each selected requirement
    for (const genReq of generatedRequirements) {
      try {
        const response = await fetch(appConfig.getUrl('/create_requirement'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${login_token}`
          },
          body: JSON.stringify({
            corporate_account: corporateAccount,
            project_id: currentProject,
            level_id: selectedLevelId,
            req_description: genReq.description,
            status: defaultSettings.status,
            req_criticality: defaultSettings.criticality || genReq.criticality,
            req_priority: defaultSettings.priority || genReq.priority,
            ref_field_1: 'Created by AI',
            ref_field_2: '',
            ref_field_3: '',
            ref_field_4: ''
          })
        });

        const data = await response.json();
        if (data.status === 'Success') {
          // Fix the undefined issue by providing fallback values
          const reqIdWithPrefix = data.req_id_with_prefix || data.req_id || 'Unknown';

          createdRequirements.push({
            id: data.req_id,
            idWithPrefix: reqIdWithPrefix,
            description: genReq.description
          });
        } else {
          failedRequirements.push({
            description: genReq.description,
            error: data.status_description || 'Unknown error'
          });
        }
      } catch (error) {
        failedRequirements.push({
          description: genReq.description,
          error: error.message
        });
      }
    }

    // Create a simple, clean message for your existing Dialog component
    if (createdRequirements.length > 0) {
      // Build a simple success message - just the requirement IDs
      let message = `Successfully created ${createdRequirements.length} requirement(s):\n\n`;

       console.log('success message 1:', message);

      // Add just the requirement IDs, one per line
      createdRequirements.forEach((req) => {
        message += `${req.idWithPrefix}\n`;
      });
        console.log('success message 2:', message);

      // Add failure info if any
      if (failedRequirements.length > 0) {
        message += `\nFailed to create ${failedRequirements.length} requirement(s)`;
      }
        console.log('success message 3:', message);

      setDialogMessage(message);
      setShowDialog(true);

      // Refresh the requirements list
      await fetchRequirements(selectedLevelId);

      // Close the AI dialog
      setIsAIDialogOpen(false);
    } else {
      setDialogMessage('Failed to create any requirements. Please try again.');
      setShowDialog(true);
    }

  } catch (error) {
    setDialogMessage(`Error creating requirements: ${error.message}`);
    setShowDialog(true);
  }
};







const handleManageCommentsClick = () => {
  setIsManageCommentsDialogOpen(true);
};

// Function to fetch product list
const fetchProductList = async () => {

console.log('fetchProductList called with:', {
corporateAccount,
currentProject,
userId
}
    );

  if (!corporateAccount || !currentProject) {
    console.log("Missing required values for fetchProductList:", {
      corporateAccount,
      currentProject

    });
    return;
  }

  try {
    const response = await fetch(appConfig.getUrl('/get_user_level_products_list'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${login_token}`
      },
      body: JSON.stringify({
        user_corporate_account: corporateAccount,
        user_id: userId,
        corporate_account: corporateAccount,
        project_id: currentProject
      })
    });

    const data = await response.json();
    console.log('Product list response:', data);

    if (data.status === 'Success') {
      setProductList(data.product_list);
    } else {
      console.error('Failed to fetch product list:', data.status_description);
    }
  } catch (error) {
    console.error('Error fetching product list:', error);
  }
};

const extractProductAccessLevels = (productList) => {
  const accessLevels = {};
  productList.forEach(product => {
    accessLevels[product.product_id] = product.access_level;
  });
  setProductAccessLevels(accessLevels);
};


const fetchClassificationOptions = async () => {
  if (!corporateAccount || !currentProject) {
    console.log("Missing required values for fetchClassificationOptions:", {
      corporateAccount,
      currentProject
    });
    return;
  }

  try {
    const response = await fetch(appConfig.getUrl('/get_statuses'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${login_token}`
      },
      body: JSON.stringify({
        corporate_account: corporateAccount,
        project_id: currentProject,
        entity: "REQUIREMENT_CLASSIFICATION",
        search_query: ""
      })
    });

    const data = await response.json();
    if (data.status === 'Success') {
      // Extract status values from the response
      const classificationValues = data.entity_statuses.map(item => item.status);
      setClassificationOptions(classificationValues);
    } else {
      console.error('Failed to fetch classification options:', data.status_description);
    }
  } catch (error) {
    console.error('Error fetching classification options:', error);
  }
};


const updateRequirementClassification = async (reqId, productId, classification) => {
  setIsUpdatingClassification(true);
  setClassificationUpdateError('');

  try {
    const response = await fetch(appConfig.getUrl('/update_requirement_classification'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${login_token}`
      },
      body: JSON.stringify({
        corporate_account: corporateAccount,
        project_id: currentProject,
        product_id: productId,
        req_ids: [reqId],
        req_classification: classification
      })
    });

    const data = await response.json();
    if (data.status === 'Success') {
      // Refresh the requirements list to show the updated classification
      await fetchRequirements(selectedLevelId);
    } else {
      // Check if there were failed requirement IDs
      if (data.failed_req_ids && data.failed_req_ids.length > 0) {
        throw new Error(`Some requirements could not be updated: ${data.failed_req_ids.join(', ')}`);
      } else {
        throw new Error(data.status_description || 'Failed to update classification');
      }
    }
  } catch (error) {
    console.error('Error updating classification:', error);
    setClassificationUpdateError(`Failed to update classification: ${error.message}`);
    setDialogMessage(`Failed to update classification: ${error.message}`);
    setShowDialog(true);
  } finally {
    setIsUpdatingClassification(false);
  }
};


// Extract access levels when productList changes
useEffect(() => {
  if (productList.length > 0) {
    extractProductAccessLevels(productList);
  }
}, [productList]);

// Fetch classification options when component loads
useEffect(() => {
  if (corporateAccount && currentProject) {
    fetchClassificationOptions();
  }
}, [corporateAccount, currentProject]);



const getCurrentFunctionalLevelDescription = () => {
  if (selectedLevelId && functionalLevelPath.length > 0) {
    // Get the last item in the path, which is the current level
    return functionalLevelPath[functionalLevelPath.length - 1].level_description;
  }
  return '';
};

const handleCopyButtonClick = () => {
  if (selectedRequirements.size !== 1) {
    setDialogMessage('Please select exactly one requirement to copy');
    setShowDialog(true);
    return;
  }

  const requirementId = Array.from(selectedRequirements)[0];
  const requirement = requirements.find(req => req.req_id === requirementId);

  if (requirement) {
    setSelectedRequirementForCopy(requirement);
    setIsCopyDialogOpen(true);
  } else {
    setDialogMessage('Selected requirement not found');
    setShowDialog(true);
  }
};


// Get the requirement ID with prefix for the selected requirement
const getSelectedRequirementIdWithPrefix = () => {
  if (selectedRequirements.size === 1) {
    const reqId = Array.from(selectedRequirements)[0];
    const requirement = requirements.find(r => r.req_id === reqId);
    return requirement ? requirement.req_id_with_prefix : '';
  }
  return '';
};


const getFunctionalLevelPath = async (levelId) => {
  console.log('getFunctionalLevelPath called with levelId:', levelId);

  if (!levelId) {
    console.warn('No levelId provided to getFunctionalLevelPath');
    return [];
  }

  if (!corporateAccount || !currentProject) {
    console.warn('Missing required parameters:', { corporateAccount, currentProject });
    return [];
  }

  try {

      console.log('Functional level path prior to the call :');

    const response = await fetch(appConfig.getUrl('/get_functional_level_path'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${login_token}`
      },
      body: JSON.stringify({
        corporate_account: corporateAccount,
        project_id: currentProject,
        level_id: levelId
      })
    });

    const data = await response.json();
    console.log('Functional level path API response:', data);

    if (data.status === 'Success') {
      if (!Array.isArray(data.level_path)) {
        console.warn('Invalid level_path format:', data.level_path);
        return [];
      }
      return data.level_path;
    } else {
      console.warn('API returned non-success status:', data);
      return [];
    }
  } catch (error) {
    console.error('Error in getFunctionalLevelPath:', error);
    return [];
  }
};


const fetchPriorities = async () => {
    try {
      console.log("Fetching priorities with:", {
        corporateAccount,
        currentProject
      });

      const response = await fetch(appConfig.getUrl('/get_statuses'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${login_token}`
        },
        body: JSON.stringify({
          corporate_account: corporateAccount,
          project_id: currentProject,
          entity: 'REQUIREMENT_PRIORITY',
          search_query: ''
        })
      });

      const data = await response.json();
      if (data.status === 'Success') {
        const priorities = data.entity_statuses.map(p => p.status);
        setAvailablePriorities(priorities);
        console.log("Fetched priorities:", priorities);
      }
    } catch (error) {
      console.error('Error fetching priorities:', error);
    }
  };

const fetchCriticalities = async () => {
  try {
    console.log("Fetching criticalities with:", {
      corporateAccount,
      currentProject
    });

    const response = await fetch(appConfig.getUrl('/get_statuses'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${login_token}`
      },
      body: JSON.stringify({
        corporate_account: corporateAccount,
        project_id: currentProject,
        entity: 'REQUIREMENT_CRITICALITY',
        search_query: ''
      })
    });

    const data = await response.json();
    if (data.status === 'Success') {
      const criticalities = data.entity_statuses.map(c => c.status);
      setAvailableCriticalities(criticalities);
      console.log("Fetched criticalities:", criticalities);
    }
  } catch (error) {
    console.error('Error fetching criticalities:', error);
  }
};

const fetchStatuses = async () => {
  try {
    console.log("Fetching statuses with:", {
      corporateAccount,
      currentProject
    });

    const response = await fetch(appConfig.getUrl('/get_statuses'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${login_token}`
      },
      body: JSON.stringify({
        corporate_account: corporateAccount,
        project_id: currentProject,
        entity: 'REQUIREMENT',
        search_query: ''
      })
    });

    const data = await response.json();
    if (data.status === 'Success') {
      const statuses = data.entity_statuses.map(s => s.status);
      setAvailableStatuses(statuses);  // Only set available statuses here
    }
  } catch (error) {
    console.error('Error fetching statuses:', error);
  }
};


useEffect(() => {
  const handleClickOutside = (event) => {
    // Handle all filter dropdowns
    const dropdowns = [
      'status-filter-dropdown',
      'criticality-filter-dropdown',
      'priority-filter-dropdown'
    ];

    dropdowns.forEach(dropdownId => {
      const dropdown = document.getElementById(dropdownId);
      if (dropdown && dropdown.style.display === 'block') {
        const isClickInside = dropdown.contains(event.target);
        const toggleButton = dropdown.previousElementSibling;
        const isClickOnToggle = toggleButton && toggleButton.contains(event.target);

        if (!isClickInside && !isClickOnToggle) {
          dropdown.style.display = 'none';
        }
      }
    });
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);

useEffect(() => {
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      // Close all filter dropdowns on escape
      const dropdowns = [
        'status-filter-dropdown',
        'criticality-filter-dropdown',
        'priority-filter-dropdown'
      ];

      dropdowns.forEach(dropdownId => {
        const dropdown = document.getElementById(dropdownId);
        if (dropdown && dropdown.style.display === 'block') {
          dropdown.style.display = 'none';
        }
      });
    }
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, []);

useEffect(() => {
  if (corporateAccount && currentProject) {
    // Fetch both statuses and criticalities
    Promise.all([
      fetchStatuses(),
      fetchCriticalities(),
      fetchPriorities()

    ]);
  }
}, [corporateAccount, currentProject]);



useEffect(() => {
    const handleDirectRequirementAccess = async () => {

      if (reqIdFromUrl && corporateAccount && currentProject) {
        try {
          // Fetch the requirement details
          const response = await fetch(appConfig.getUrl('/get_requirement_details'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${login_token}`
            },
            body: JSON.stringify({
              corporate_account: corporateAccount,
              project_id: currentProject,
              req_id: reqIdFromUrl
            })
          });

          const data = await response.json();

          console.log('response from get req details :', data);
                    console.log('response from get req details - status :', data.status);
          console.log('response from get req details - requirement:', data.requirement_details);

          if (data.status === 'Success' && data.requirement_details) {
                    console.log('hello 1');

            // Get the functional level path for this requirement
            const levelPath = await getFunctionalLevelPath(data.requirement_details.level_id);
            setFunctionalLevelPath(levelPath || []);

            // Set the selected level ID
            setSelectedLevelId(data.requirement_details.level_id);

            // Select this requirement
            setSelectedRequirements(new Set([data.requirement_details.req_id]));

            // Set the requirement for edit and open the dialog
            setSelectedRequirementForEdit(data.requirement_details);
            setIsEditMode(true);
            setIsCreateDialogOpen(true);
          } else {
                              console.log('hello 2');

            setDialogMessage('Could not find the specified requirement');
            setShowDialog(true);
          }
        } catch (error) {
          console.error('Error fetching requirement details:', error);
          setDialogMessage('Error loading the requirement');
          setShowDialog(true);
        }
      }
    };

    handleDirectRequirementAccess();
}, [reqIdFromUrl, corporateAccount, currentProject]);



useEffect(() => {
  console.log('functionalLevelPath updated:', functionalLevelPath);
}, [functionalLevelPath]);

useEffect(() => {
  if (selectedLevelId) {
    handleLevelSelect(selectedLevelId);
  }
}, [selectedLevelId]);


useEffect(() => {
  if (selectedLevelId && functionalLevelPath.length === 0) {
    handleLevelSelect(selectedLevelId);
  }
}, [selectedLevelId]);

useEffect(() => {
  if (availableStatuses.length > 0) {
    console.log("Setting default status filters:", availableStatuses);

    setStatusFilter([]);



  }
}, [availableStatuses]);

useEffect(() => {
  if (availableStatuses && availableStatuses.length > 0) {
    // Only set the status filter if it's currently empty
    if (statusFilter.length === 0) {
      console.log("Setting default status filters:", availableStatuses);
      setStatusFilter([...availableStatuses]);
    }
  }
}, [availableStatuses]);





const checkPermissionNew = async (categoryHeader) => {
    try {
      const response = await fetch(appConfig.getUrl('/get_user_access_level_new'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${login_token}`
        },
        body: JSON.stringify({
          corporate_account: corporateAccount,
          user_id: userId,
          project_id: currentProject,
          category_header: categoryHeader,
          category_sub_header: []
        }),
      });

      const data = await response.json();


      // Map API response to permission fields
      data.user_actions_list.forEach(item => {
        switch(item.user_action) {
          case 'Create Or Edit Requirement':
            permissions.canUpdate = item.has_access;
            break;
          case 'Update Status':
            permissions.canUpdateStatus = item.has_access;
            break;
          case 'Update Priority':
            permissions.canUpdatePriority = item.has_access;
            break;
          case 'Update Criticality':
            permissions.canUpdateCriticality = item.has_access;
            break;
          case 'Copy Requirement':
            permissions.canCopy = item.has_access;
            break;
          case 'Approve Requirements':
            permissions.canApprove = item.has_access;
            break;
          case 'Update Product Classification':
            permissions.canUpdateClassification = item.has_access;
            break;
          case 'Create Or Edit Exception':
            permissions.canCreateException = item.has_access;
            break;
          case 'Delete Exception':
            permissions.canDeleteException = item.has_access;
            break;

        }
      });

        console.log(`New  access permissions data  : `, data);
        console.log('New Permissions:', permissions);

      return data.access_status && data.status === 'Success';
    } catch (error) {
      console.error(`Error checking permission for {categoryHeader}:`, error);
      return false;
    }
  };



  useEffect(() => {
    const checkAllPermissions = async () => {
      if (corporateAccount && userId && currentProject) {
        const [] = await Promise.all([
            checkPermissionNew('Requirements Management'),
        ]);

        setPermissions({ ...permissions });

      }
    };
    checkAllPermissions();
  }, [corporateAccount, userId, currentProject]);


// Add this new useEffect right after your other useEffects
useEffect(() => {
  if (availableStatuses.length > 0) {
    console.log("Setting default status filters:", availableStatuses);

setStatusFilter([]);

  }
}, [availableStatuses]);

useEffect(() => {
  console.log("selectedLevelId changed:", selectedLevelId);
}, [selectedLevelId]);


 useEffect(() => {
  const setInitialLoad = async () => {
    const current_project = localStorage.getItem('current_project');
    if (!login_token) {
      showErrorDialog('Invalid login credentials. Please login first', '/LoginAndAuthentication');
      return;
    }
    try {
      const result = await getUserInfo({
        login_token: login_token
      });

      if (result.success) {
        if (result.userInfo.default_project == 'null' && current_project == 'null') {
          showErrorDialog('Please select a project on the home page', '/RequirementsPortal');
          return;
        }
        const project = current_project === 'null' ? result.userInfo.default_project : current_project;

        // Set these states first
        setCorporateAccount(result.userInfo.corporate_account);
        setCurrentProject(project);
        setUserId(result.user_id);
        setUserName(result.userInfo.user_name);
        setAccountDescription(result.userInfo.account_description);

        // Then fetch statuses and functional levels
        await fetchStatuses();

        // After setting the state, fetch functional levels
        try {
          const response = await fetch(appConfig.getUrl('/get_functional_levels'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${login_token}`
            },
            body: JSON.stringify({
              corporate_account: result.userInfo.corporate_account,
              project_id: project,
              parent_level_id: null
            })
          });

          const data = await response.json();
          if (data.status === 'Success') {
            setFunctionalLevels(data.functional_level_list);
          }
        } catch (error) {
          console.error('Error fetching functional levels:', error);
        }

      } else {
        showErrorDialog('Invalid login credentials. Please login again', '/LoginAndAuthentication');
      }
    } catch (error) {
      console.error('Error calling API:', error);
    }
  };

  setInitialLoad();
}, []);


// Reset to first page when search or filters change
useEffect(() => {
  setCurrentPage(1);
}, [searchFilter, statusFilter, criticalityFilter, priorityFilter, dateRangeFilter, sortConfig]);

// Ensure currentPage is valid after requirements change
useEffect(() => {
  // Calculate totalPages inside the effect instead of depending on it
  const calculatedTotalPages = Math.ceil(requirements.length / itemsPerPage);
  if (currentPage > Math.max(1, calculatedTotalPages)) {
    setCurrentPage(Math.max(1, calculatedTotalPages));
  }
}, [requirements, currentPage, itemsPerPage]);







const fetchRequirements = async (levelId) => {

console.log("Fetching requirements with:", {
    corporateAccount,
    currentProject,
    levelId,
    selectedProducts,
    statusFilter,
    searchFilter,
    sortConfig,
    criticalityFilter,
    priorityFilter,
    dateRangeFilter,
    updatedDateRangeFilter,
    includeChildLevels
    });



  if (!corporateAccount || !currentProject) {
    console.log("Missing required values for fetchRequirements:", {
      corporateAccount,
      currentProject
    });
    return;
  }

  setRequirements([]);
  try {
    const response = await fetch(appConfig.getUrl('/get_requirements_list'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${login_token}`
      },
      body: JSON.stringify({
        corporate_account: corporateAccount,
        project_id: currentProject,
        level_id: levelId,
        product_ids: selectedProducts.map(product => product.product_id.toString()),
        filter_by_status: statusFilter,
        search_query: searchFilter,
        sort_criteria: sortConfig.key ? `${sortConfig.key} ${sortConfig.direction}` : null,
        requirement_criticality: criticalityFilter,
        requirement_priority: priorityFilter,
        created_date_start: dateRangeFilter.startDate,
        created_date_end: dateRangeFilter.endDate,
        updated_date_start: updatedDateRangeFilter.startDate,
        updated_date_end: updatedDateRangeFilter.endDate,
        include_child_levels_flag: includeChildLevels, // Add the new flag here
        user_timezone: userTimezone
      })
    });

    const data = await response.json();
    if (data.status === 'Success') {
      if (data.requirement_list && data.requirement_list.length > 0) {
        console.log("Sample requirement data:", data.requirement_list[0]);
      }

      setRequirements(data.requirement_list);
    }
  } catch (error) {
    console.error('Error fetching requirements:', error);
  }
};





// Fetch products when component loads
useEffect(() => {

    console.log("Fetching product list with:", {
    corporateAccount,
    currentProject
    }
    );

  if (corporateAccount && currentProject) {
    fetchProductList();
  }
}, [corporateAccount, currentProject]);









useEffect(() => {
  fetchRequirements(selectedLevelId);
}, [selectedLevelId, statusFilter, criticalityFilter, priorityFilter, dateRangeFilter,
    updatedDateRangeFilter, sortConfig, searchFilter, includeChildLevels, selectedProducts]);






// Add product selector component
const ProductSelector = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  // Handle clicking outside to close the dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }

    // Only add the listener when the dropdown is open
    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  // Filter products based on search term
  const filteredProducts = searchTerm
    ? productList.filter(product =>
        product.product_name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : productList;

  // Toggle product selection
  const toggleProductSelection = (product) => {
    // Check if already selected
    const isSelected = selectedProducts.some(p => p.product_id === product.product_id);

    if (isSelected) {
      // If selected, remove it
      setSelectedProducts(prevSelected =>
        prevSelected.filter(p => p.product_id !== product.product_id)
      );
    } else {
      // If not selected, check if we're at the limit
      if (selectedProducts.length >= 5) {
        setDialogMessage('You can select up to 5 products for comparison');
        setShowDialog(true);
        return;
      }

      // Add to selection
      setSelectedProducts(prevSelected => [...prevSelected, product]);
    }

    // Refresh requirements data with updated selection
    if (selectedLevelId) {
      setTimeout(() => {
        fetchRequirements(selectedLevelId);
      }, 100);
    }
  };

  // Handle "Clear All" button
  const handleClearAll = () => {
    setSelectedProducts([]);
    if (selectedLevelId) {
      setTimeout(() => {
        fetchRequirements(selectedLevelId);
      }, 100);
    }
  };

  return (





<div className={`mb-2 bg-white rounded-lg shadow transition-all duration-300 ${showProductComparison ? 'p-2' : 'p-1'}`}>


  <div className="flex items-center justify-between">
    {/* Toggle button for Product Comparison */}
    <button
      onClick={() => setShowProductComparison(!showProductComparison)}
      className="flex items-center px-3 py-1 text-sm text-blue-600 hover:text-blue-800 transition-colors"
    >
      {showProductComparison ? <EyeOff size={16} /> : <Eye size={16} />}
      <span className="ml-2 font-medium">
        {showProductComparison ? 'Hide' : 'Show'} Product Comparison
      </span>
      {showProductComparison ? <ChevronUp size={16} className="ml-1" /> : <ChevronDown size={16} className="ml-1" />}
    </button>

    {/* When collapsed, show selected count */}
    {!showProductComparison && selectedProducts.length > 0 && (
      <div className="text-sm text-purple-600">
        {selectedProducts.length} product{selectedProducts.length !== 1 ? 's' : ''} selected
      </div>
    )}
  </div>






  {/* Collapsible content */}
  {showProductComparison && (
    <div className="mt-2">

 <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="relative mr-4" ref={dropdownRef}>
            {/* Dropdown toggle button */}
            <button
              type="button"
              className="px-2 py-1 bg-purple-500 text-white rounded text-xs hover:bg-purple-600 flex items-center"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              <span>Select Products For Comparison</span>
              <ChevronDown size={14} className="ml-1" />
            </button>

            {/* Dropdown menu */}
            {isDropdownOpen && (
              <div
                className="absolute left-0 mt-1 bg-white border rounded shadow-lg z-10 w-96"
              >
                {/* Search input */}
                <div className="px-3 py-2 border-b">
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="Search products..."
                    className="w-full p-1.5 border rounded text-xs"
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>

                {/* Action buttons */}
                <div className="px-3 py-2 border-b flex justify-between">
                  <button
                    type="button"
                    className="text-xs text-blue-600 hover:text-blue-800"
                    onClick={(e) => {
                      e.stopPropagation();

                      // Get products that aren't already selected
                      const unselectedProducts = filteredProducts.filter(
                        product => !selectedProducts.some(p => p.product_id === product.product_id)
                      );

                      // Calculate how many more we can add
                      const availableSlots = 5 - selectedProducts.length;

                      if (availableSlots <= 0) {
                        setDialogMessage('You can select up to 5 products for comparison');
                        setShowDialog(true);
                        return;
                      }

                      // Add only as many as we have slots for
                      const productsToAdd = unselectedProducts.slice(0, availableSlots);

                      if (productsToAdd.length > 0) {
                        setSelectedProducts([...selectedProducts, ...productsToAdd]);

                        // Refresh requirements
                        if (selectedLevelId) {
                          setTimeout(() => {
                            fetchRequirements(selectedLevelId);
                          }, 100);
                        }
                      }
                    }}
                  >
                    Select All Visible
                  </button>
                  <button
                    type="button"
                    className="text-xs text-red-600 hover:text-red-800"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleClearAll();
                    }}
                  >
                    Clear All
                  </button>
                </div>

                {/* Product list */}
                <div className="max-h-60 overflow-y-auto">
                  {filteredProducts.length === 0 ? (
                    <div className="p-3 text-center text-xs text-gray-500">
                      No products found
                    </div>
                  ) : (
                    filteredProducts.map(product => {
                      const isSelected = selectedProducts.some(p => p.product_id === product.product_id);

                      return (
                        <div
                          key={product.product_id}
                          className={`px-3 py-2 hover:bg-gray-100 ${isSelected ? 'bg-purple-50' : ''}`}
                        >
                          <label className="flex items-center w-full cursor-pointer">
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={(e) => {
                                // This prevents the dropdown from closing
                                e.stopPropagation();
                                toggleProductSelection(product);
                              }}
                              className="mr-2"
                            />
                            <div className="text-xs">
                              <span className="font-medium">{product.product_name}</span>
                              {product.product_company && (
                                <span className="text-gray-600"> - {product.product_company}</span>
                              )}
                            </div>
                          </label>
                        </div>
                      );
                    })
                  )}
                </div>

                {/* Footer */}
                <div className="px-3 py-2 border-t flex justify-between items-center">
                  <span className="text-xs text-gray-600">
                    {selectedProducts.length} of 5 selected
                  </span>
                  <button
                    type="button"
                    className="px-3 py-1 text-xs bg-purple-500 text-white rounded"
                    onClick={() => setIsDropdownOpen(false)}
                  >
                    Done
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Selected products display */}
          <div className="flex gap-4 overflow-x-auto whitespace-nowrap">
            {selectedProducts.length > 0 ? (
              selectedProducts.map(product => (
                <div
                  key={product.product_id}
                  className="flex items-center bg-purple-100 text-purple-800 px-2 py-1 rounded text-xs min-w-[180px] justify-between"
                >
                  <span className="mr-1 truncate max-w-[140px]">{product.product_name}</span>
                  <button
                    type="button"
                    onClick={() => {
                      setSelectedProducts(selectedProducts.filter(p => p.product_id !== product.product_id));
                      if (selectedLevelId) {
                        setTimeout(() => {
                          fetchRequirements(selectedLevelId);
                        }, 100);
                      }
                    }}
                    className="text-purple-600 hover:text-purple-800"
                  >
                    <X size={12} />
                  </button>
                </div>
              ))
            ) : (
              <span className="text-xs text-purple-500">Select products for comparison (max 5)</span>
            )}
          </div>


        {/* Clear all button */}
        {selectedProducts.length > 0 && (
          <button
            type="button"
            onClick={handleClearAll}
         className="ml-auto px-3 py-1 text-xs bg-red-300 text-white rounded hover:bg-red-500 flex items-center">
            x Clear Product Selection
          </button>
        )}
        </div>
      </div>






      </div>
)}









    </div>
  );
};














// Replace the DateRangePicker component in BaseRequirementsManagement.js with this updated version:

const DateRangePicker = ({ label = "Creation Date", value, onChange, icon = <Calendar size={16} />, color = "gray" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [localDateRange, setLocalDateRange] = useState(value);
  const dropdownRef = useRef(null);

  // Update local state when props change
  useEffect(() => {
    setLocalDateRange(value);
  }, [value]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleToggle = () => setIsOpen(!isOpen);

  const clearDates = () => {
    setLocalDateRange({ startDate: '', endDate: '' });
  };

  const handleApply = () => {
    onChange(localDateRange);
    setIsOpen(false);
  };

  // Helper function to format date in local timezone as YYYY-MM-DD
  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Handle quick selections with local timezone
  const handleQuickSelect = (option) => {
    const today = new Date();
    let startDate = '';
    let endDate = '';

    switch(option) {
      case 'today':
        startDate = formatLocalDate(today);
        endDate = startDate;
        break;
      case 'yesterday': {
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        startDate = formatLocalDate(yesterday);
        endDate = startDate;
        break;
      }
      case 'thisWeek': {
        const thisMonday = new Date(today);
        const day = thisMonday.getDay();
        const diff = thisMonday.getDate() - day + (day === 0 ? -6 : 1); // Adjust for Sunday
        thisMonday.setDate(diff);
        startDate = formatLocalDate(thisMonday);
        endDate = formatLocalDate(today);
        break;
      }
      case 'lastWeek': {
        const lastMonday = new Date(today);
        const day = lastMonday.getDay();
        lastMonday.setDate(lastMonday.getDate() - day - 6); // Last Monday
        startDate = formatLocalDate(lastMonday);

        const lastSunday = new Date(lastMonday);
        lastSunday.setDate(lastSunday.getDate() + 6);
        endDate = formatLocalDate(lastSunday);
        break;
      }
      case 'thisMonth': {
        const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        startDate = formatLocalDate(firstOfMonth);
        endDate = formatLocalDate(today);
        break;
      }
      case 'lastMonth': {
        const firstOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        startDate = formatLocalDate(firstOfLastMonth);

        const lastOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        endDate = formatLocalDate(lastOfLastMonth);
        break;
      }
      default:
        break;
    }

    setLocalDateRange({ startDate, endDate });
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    try {
      // Parse the date string (expected format: YYYY-MM-DD)
      const [year, month, day] = dateStr.split('-');

      // Create a date string that includes the time to ensure correct display
      // Force the time to be noon to avoid any timezone issues across midnight
      const dateObj = new Date(`${year}-${month}-${day}T12:00:00`);

      // Format the date
      const options = { month: 'short', day: 'numeric', year: 'numeric' };
      return dateObj.toLocaleDateString('en-US', options);
    } catch (e) {
      console.error("Date formatting error:", e);

      // Fallback manual formatting
      try {
        const [year, month, day] = dateStr.split('-');
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return `${monthNames[parseInt(month) - 1]} ${parseInt(day)}, ${year}`;
      } catch {
        return dateStr; // Last resort: return the original string
      }
    }
  };

  // Calculate display values after applying the formatDate function
  let startDateDisplay = 'Any';
  let endDateDisplay = 'Any';

  if (value.startDate) {
    startDateDisplay = formatDate(value.startDate);
  }

  if (value.endDate) {
    endDateDisplay = formatDate(value.endDate);
  }

  const displayValue = value.startDate || value.endDate
    ? `${startDateDisplay} - ${endDateDisplay}`
    : 'Any date';

  // Debug the date values
  useEffect(() => {
    if (value.startDate || value.endDate) {
      console.log('Date filter values:', {
        startDate: value.startDate,
        formattedStartDate: formatDate(value.startDate),
        endDate: value.endDate,
        formattedEndDate: formatDate(value.endDate)
      });
    }
  }, [value.startDate, value.endDate]);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={handleToggle}
        className="flex items-center p-2 rounded border bg-green-50 text-green-700"
      >
        <Calendar size={16} className="text-green-700" />
        <span className="ml-2 text-xs">{label}: {displayValue}</span>
        <ChevronDown size={16} className="ml-2 text-green-700" />
      </button>

      {isOpen && (
        <div className="absolute mt-1 bg-white border rounded shadow-lg z-10 w-72 p-3">
          {/* Quick select options */}
          <div className="mb-3 border-b pb-2">
            <label className="block text-sm font-medium mb-2">Quick Select:</label>
            <div className="grid grid-cols-2 gap-2">
              <button
                onClick={() => handleQuickSelect('today')}
                className="p-2 text-xs bg-green-50 hover:bg-green-100 rounded text-green-700"
              >
                Today
              </button>
              <button
                onClick={() => handleQuickSelect('yesterday')}
                className="p-2 text-xs bg-green-50 hover:bg-green-100 rounded text-green-700"
              >
                Yesterday
              </button>
              <button
                onClick={() => handleQuickSelect('thisWeek')}
                className="p-2 text-xs bg-green-50 hover:bg-green-100 rounded text-green-700"
              >
                This Week
              </button>
              <button
                onClick={() => handleQuickSelect('lastWeek')}
                className="p-2 text-xs bg-green-50 hover:bg-green-100 rounded text-green-700"
              >
                Last Week
              </button>
              <button
                onClick={() => handleQuickSelect('thisMonth')}
                className="p-2 text-xs bg-green-50 hover:bg-green-100 rounded text-green-700"
              >
                This Month
              </button>
              <button
                onClick={() => handleQuickSelect('lastMonth')}
                className="p-2 text-xs bg-green-50 hover:bg-green-100 rounded text-green-700"
              >
                Last Month
              </button>
            </div>
          </div>

          <div className="mb-3">
            <label className="block text-sm font-medium mb-1">Start Date:</label>
            <input
              type="date"
              value={localDateRange.startDate}
              onChange={(e) => setLocalDateRange({ ...localDateRange, startDate: e.target.value })}
              className="w-full p-2 border rounded"
            />
          </div>
          <div className="mb-3">
            <label className="block text-sm font-medium mb-1">End Date:</label>
            <input
              type="date"
              value={localDateRange.endDate}
              onChange={(e) => setLocalDateRange({ ...localDateRange, endDate: e.target.value })}
              className="w-full p-2 border rounded"
            />
          </div>
          <div className="flex justify-between">
            <button
              onClick={clearDates}
              className="text-xs text-red-600"
            >
              Clear
            </button>
            <button
              onClick={handleApply}
              className="px-3 py-1 text-sm bg-green-500 text-white rounded"
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};



const handleUpdateStatus = async (newStatus) => {
  try {
    const response = await fetch(appConfig.getUrl('/update_requirement_status'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${login_token}`
      },
      body: JSON.stringify({
        corporate_account: corporateAccount,
        project_id: currentProject,
        req_ids: Array.from(selectedRequirements),
        status: newStatus
      })
    });

    const data = await response.json();
    if (data.status === 'Success') {
      setIsUpdateStatusDialogOpen(false);
      await fetchRequirements(selectedLevelId);
      setSelectedRequirements(new Set());
    } else {
      throw new Error(data.status_description || 'Failed to update status');
    }
  } catch (error) {
    setDialogMessage(error.message);
    setShowDialog(true);
  }
};

const handleUpdateCriticality = async (newCriticality) => {
  try {
    const response = await fetch(appConfig.getUrl('/update_requirement_criticality'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${login_token}`
      },
      body: JSON.stringify({
        corporate_account: corporateAccount,
        project_id: currentProject,
        req_ids: Array.from(selectedRequirements),
        req_criticality: newCriticality
      })
    });

    const data = await response.json();
    if (data.status === 'Success') {
      setIsUpdateCriticalityDialogOpen(false);
      await fetchRequirements(selectedLevelId);
      setSelectedRequirements(new Set());
    } else {
      throw new Error(data.status_description || 'Failed to update criticality');
    }
  } catch (error) {
    setDialogMessage(error.message);
    setShowDialog(true);
  }
};

const handleUpdatePriority = async (newPriority) => {
  try {
    const response = await fetch(appConfig.getUrl('/update_requirement_priority'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${login_token}`
      },
      body: JSON.stringify({
        corporate_account: corporateAccount,
        project_id: currentProject,
        req_ids: Array.from(selectedRequirements),
        req_priority: newPriority
      })
    });

    const data = await response.json();
    if (data.status === 'Success') {
      setIsUpdatePriorityDialogOpen(false);
      await fetchRequirements(selectedLevelId);
      setSelectedRequirements(new Set());
    } else {
      throw new Error(data.status_description || 'Failed to update priority');
    }
  } catch (error) {
    setDialogMessage(error.message);
    setShowDialog(true);
  }
};




const handleExportToCSV = async () => {
  if (!selectedLevelId && requirements.length === 0) {
    setDialogMessage('No data available to export. Please select a functional level or ensure requirements are loaded.');
    setShowDialog(true);
    return;
  }

  try {
    const response = await fetch(appConfig.getUrl('/export_requirements_to_csv'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${login_token}`
      },
      body: JSON.stringify({
        corporate_account: corporateAccount,
        project_id: currentProject,
        level_id: selectedLevelId,
        include_child_levels_flag: includeChildLevels,
        req_type: 'REQUIREMENTS'
      })
    });

    if (response.ok) {
      // Get the filename from the response headers
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = 'requirements_export.csv';
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      // Create blob and download
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setDialogMessage('Requirements exported successfully!');
      setShowDialog(true);
    } else {
      const errorData = await response.json();
      setDialogMessage(`Export failed: ${errorData.status_description || 'Unknown error'}`);
      setShowDialog(true);
    }
  } catch (error) {
    setDialogMessage(`Export failed: ${error.message}`);
    setShowDialog(true);
  }
};





  const handleSort = (key) => {
    setSortConfig(prevConfig => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

const handleSearch = () => {
  setSearchFilter(searchInput); // This will trigger the useEffect and API call
};

const handleSearchInputChange = (e) => {
  const newValue = e.target.value;
  setSearchInput(newValue);

  // If the input is cleared (empty), trigger search immediately
  if (newValue === '') {
    setSearchFilter('');
  }
};

const fetchChildLevels = async (parentId) => {

console.log(`parentId  : ${parentId}`);
console.log(`corporateAccount  : ${corporateAccount}`);
console.log(`currentProject  : ${currentProject}`);


    try {
      const response = await fetch(appConfig.getUrl('/get_functional_levels'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${login_token}`
        },
        body: JSON.stringify({
          corporate_account: corporateAccount,
          project_id: currentProject,
          parent_level_id: parentId
        })
      });

      const data = await response.json();
      if (data.status === 'Success') {
        setChildLevels(prev => ({
          ...prev,
          [parentId]: data.functional_level_list
        }));
      }
    } catch (error) {
      console.error('Error fetching child levels:', error);
    }
  };




const handleLevelSelect = async (levelId) => {
  console.log('handleLevelSelect called with levelId:', levelId);

  setSelectedLevelId(levelId);
  setSelectedRequirements(new Set());

  if (levelId) {
    try {
      const path = await getFunctionalLevelPath(levelId);
      console.log('Path received from API:', path);
      setFunctionalLevelPath(path || []);
    } catch (error) {
      console.error('Error getting functional level path:', error);
      setFunctionalLevelPath([]);
    }
  } else {
    setFunctionalLevelPath([]);
  }
};



  const toggleLevel = (levelId) => {
    const newExpanded = new Set(expandedLevels);
    if (newExpanded.has(levelId)) {
      newExpanded.delete(levelId);
    } else {
      newExpanded.add(levelId);
    }
    setExpandedLevels(newExpanded);
  };

 const renderFunctionalLevels = (levels) => {
  if (!levels || levels.length === 0) return null;

  return levels.map(level => (
    <div key={level.level_id}>
      <div
        className={`flex items-center py-2 cursor-pointer ${
          selectedLevelId === level.level_id ? 'bg-blue-100' : ''
        }`}
        style={{
          backgroundColor: selectedLevelId === level.level_id ? '#DBEAFE' : 'transparent', // Light blue for selected
          color: selectedLevelId === level.level_id ? '#1E40AF' : 'white', // Dark blue text for selected, white for others
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => {
          if (selectedLevelId !== level.level_id) {
            e.currentTarget.style.backgroundColor = '#fcfafc'; // Light yellow hover
            e.currentTarget.style.color = '#007bff'; // Dark yellow/brown text
          }
        }}
        onMouseLeave={(e) => {
          if (selectedLevelId !== level.level_id) {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = 'white';
          }
        }}
        onClick={() => handleLevelSelect(level.level_id)}
      >
        <button
          className="p-1 rounded"
          style={{
            backgroundColor: 'transparent',
            transition: 'background-color 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
          onClick={async (e) => {
            e.stopPropagation();
            if (!childLevels[level.level_id]) {
              await fetchChildLevels(level.level_id);
            }
            toggleLevel(level.level_id);
          }}
        >
          {expandedLevels.has(level.level_id) ? (
            <ChevronDown size={14} />
          ) : (
            <ChevronRight size={14} />
          )}
        </button>
        <span className="ml-2 text-sm">{level.level_description}</span>
      </div>
      <div style={{ marginLeft: '20px' }}>
        {expandedLevels.has(level.level_id) &&
          childLevels[level.level_id] &&
          renderFunctionalLevels(childLevels[level.level_id])}
      </div>
    </div>
  ));
};



// Add this pagination calculation logic
const totalPages = Math.ceil(requirements.length / itemsPerPage);
const startIndex = (currentPage - 1) * itemsPerPage;
const paginatedRequirements = requirements.slice(startIndex, startIndex + itemsPerPage);

return (
    <div className="min-h-screen bg-gray-50">
      <Header />

  <div style={{ marginTop: '48px' }}>
    {/* Compressed single-row header layout */}
    <div className="pt-2 pb-2">
      {/* Search row with icon moved to the right */}
      <div className="flex items-center px-6 mb-0 justify-between">

        <div className="w-80">


        <div className="flex items-center relative">
          <input
            type="text"
            value={searchInput}
            onChange={handleSearchInputChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
            placeholder="Search requirements..."
            className="p-2 pr-4 border rounded w-full"
          />
          {/* Added search button to the right of the input */}
          <button
            onClick={handleSearch}
            className="ml-2 p-1 rounded bg-blue-500 hover:bg-blue-600 text-white"
            aria-label="Search"
          >
            <Search size={16} />
          </button>
        </div>
        </div>

  <h1 className="text-xl font-bold text-center flex-1">Manage Requirements</h1>


  <div className="w-80"></div>



      </div>


<div className="flex items-center px-6 mb-0 bg-blue-100 py-0 rounded-lg">
  {/* Functional Level Path - Left aligned */}
  <div className="flex-1 text-left">
    <span className="text-base font-bold text-blue-700" >Functional Level Path: </span>
    <span className="text-sm">
      {functionalLevelPath.length > 0 ? (
        <>
          {functionalLevelPath.map((level, index) => (
            <span key={level.level_id} className="inline-flex items-center">
              <button
                className="text-green-600 hover:text-green-800"
                onClick={() => handleLevelSelect(level.level_id)}
              >
                {level.level_description}
              </button>
              {index < functionalLevelPath.length - 1 && (
                <span className="mx-1 text-gray-400">/</span>
              )}
            </span>
          ))}
        </>
      ) : selectedLevelId ? (
        <span>Fetching path information...</span>
      ) : <span style={{ color: 'red' }}>None Selected</span>}
    </span>

    {/* Only show Clear Selection button when a functional level is selected */}
    {selectedLevelId && (
      <button
        onClick={() => {
          setSelectedLevelId(null);
          setFunctionalLevelPath([]);
          fetchRequirements(null);
        }}
        className="px-3 py-1 text-xs bg-red-300 text-white rounded hover:bg-red-500 items-center ml-4">
        X Clear Selection
      </button>
    )}
  </div>


  {/* Project name - Center aligned */}
  <div className="flex-1 text-center">
    <h2 className="text-base font-bold text-blue-700">Project: {currentProject}</h2>
  </div>





 <div className="flex-1 flex justify-end items-center gap-2 relative group">
  <button
    disabled={!permissions.canUpdate || !selectedLevelId}
    onClick={() => {
      if (selectedLevelId) {
        setSelectedRequirementForEdit(null);
        setIsEditMode(false);
        setIsCreateDialogOpen(true);
      } else {
        setDialogMessage('Please select a functional level from the left panel first');
        setShowDialog(true);
      }
    }}
className={`flex items-center px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 whitespace-nowrap ${!permissions.canUpdate || !selectedLevelId ? 'opacity-50' : ''}`}

  >
    <Plus size={18} className="mr-2" />
    <span>Create New Requirement</span>
  </button>





  <button
    className={`flex items-center px-3 py-2 rounded text-sm whitespace-nowrap ${
      !permissions.canUpdate || !selectedLevelId
        ? 'text-gray-300'
        : 'text-blue-800 hover:text-blue-900'
    }`}
    disabled={!permissions.canUpdate || !selectedLevelId}
    onClick={() => setIsAIDialogOpen(true)}
  >
    <Sparkles className="mr-2" size={20} />
    <span className={!selectedLevelId ? 'text-blue-500 text-lg' : 'text-blue-800 text-lg'}>
      Generate Requirements Using AI
    </span>
  </button>



  {/* Keep tooltip for informational purposes */}
  {(!permissions.canUpdate || !selectedLevelId) && (
    <div className="absolute right-0 top-full mt-2 px-3 py-2 bg-gray-600 text-white text-xs rounded shadow-lg invisible group-hover:visible whitespace-nowrap z-20">
      {!selectedLevelId
        ? "Select a functional level from the left panel to enable this button"
        : !permissions.canUpdate
        ? "Note: You do not have permission to create requirements"
        : ""}
      <div className="absolute bottom-full right-4 w-0 h-0 border-l-4 border-r-4 border-b-4 border-transparent border-b-gray-600"></div>
    </div>
  )}
</div>





</div>



    </div>
  </div>

      <div className="flex h-[calc(100vh-64px)]">




            {/* Left Panel - Functional Levels */}
            <div className="mt-0 w-64 text-white bg-blue-800 border-r  overflow-y-auto">
              <div className="p-4">
                {/* Add the checkbox above the heading */}
                <div className="mb-3 flex items-center">
                  <input
                    type="checkbox"
                    id="includeChildLevels"
                    checked={includeChildLevels}
                    onChange={(e) => setIncludeChildLevels(e.target.checked)}
                    className="mr-2"
                  />
                  <label htmlFor="includeChildLevels" className="text-sm text-whit">
                    Show reqs from child levels
                  </label>
                </div>

<div className="flex justify-center items-center mb-4 bg-white p-2 rounded-lg shadow">
  <h2 className="font-semibold text-sm text-blue-600">Select Functional Level</h2>
</div>

                {renderFunctionalLevels(functionalLevels)}
              </div>
            </div>



 {/* Main Content */}
<div className="flex-1 overflow-y-auto p-0 relative">


  {/* Product selector */}
  <ProductSelector />
{/* Filters section in the UI */}


<div className={`mb-2 bg-white rounded-lg shadow transition-all duration-300 ${showFilters ? 'p-2' : 'p-1'}`}>
  <div className="flex items-center justify-between mb-2">
    {/* Toggle button for Filters */}
    <button
      onClick={() => setShowFilters(!showFilters)}
      className="flex items-center px-3 py-1 text-sm text-blue-600 hover:text-blue-800 transition-colors"
    >
      {showFilters ? <EyeOff size={16} /> : <Eye size={16} />}
      <span className="ml-2 font-medium">
        {showFilters ? 'Hide' : 'Show'} Filters
      </span>
      {showFilters ? <ChevronUp size={16} className="ml-1" /> : <ChevronDown size={16} className="ml-1" />}
    </button>

    {/* When collapsed, show active filter count */}
    {!showFilters && (
      <div className="text-sm text-gray-600">
        {[
          statusFilter.length > 0 && `${statusFilter.length} status`,
          criticalityFilter.length > 0 && `${criticalityFilter.length} criticality`,
          priorityFilter.length > 0 && `${priorityFilter.length} priority`,
          (dateRangeFilter.startDate || dateRangeFilter.endDate) && 'creation date',
          (updatedDateRangeFilter.startDate || updatedDateRangeFilter.endDate) && 'update date'
        ].filter(Boolean).join(', ') || 'No active filters'}
      </div>
    )}
  </div>





{/* Collapsible filters content */}
{showFilters && (
  <div className="flex flex-col gap-3">
    <div className="flex flex-wrap gap-3 items-center">
      <div className="flex items-center">
        <Filter size={18} className="text-gray-600 ml-2 mr-2" />
        <span className="text-sm font-medium text-gray-700">Filters:</span>
      </div>

      {/* Status Filter Dropdown */}
      <div className="relative" style={{ minWidth: '220px' }}>
        <div
          className="p-2 border rounded flex justify-between items-center cursor-pointer bg-yellow-50 text-yellow-700"
          onClick={() => {
            const dropdown = document.getElementById('status-filter-dropdown');
            if (dropdown) {
              dropdown.style.display = dropdown.style.display === 'none' ? 'block' : 'none';
            }
          }}
        >
          <div className="flex items-center">
            <img src="/icons/noun-status-5702263-FF824A.svg" alt="Status" className="w-6 h-6 mr-2" />
            <span className="text-xs truncate" style={{ maxWidth: '150px' }}>
              Status ({statusFilter.length})
            </span>
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>

        <div
          id="status-filter-dropdown"
          className="absolute left-0 right-0 mt-1 bg-white border rounded shadow-lg z-10"
          style={{ display: 'none', maxHeight: '250px', overflowY: 'auto' }}
        >
          <div className="p-2 border-b sticky top-0 bg-white">
            <div className="flex justify-between items-center">
              <button
                className="text-xs text-blue-600 hover:text-blue-800"
                onClick={(e) => {
                  e.stopPropagation();
                  setStatusFilter([...availableStatuses]);
                }}
              >
                Select All
              </button>
              <button
                className="text-xs text-blue-600 hover:text-blue-800"
                onClick={(e) => {
                  e.stopPropagation();
                  setStatusFilter([]);
                }}
              >
                Clear All
              </button>
            </div>
          </div>

          {availableStatuses.map(status => (
            <div
              key={status}
              className="p-2 hover:bg-gray-100 cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setStatusFilter(prev => {
                  if (prev.includes(status)) {
                    return prev.filter(s => s !== status);
                  } else {
                    return [...prev, status];
                  }
                });
              }}
            >
              <label className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={statusFilter.includes(status)}
                  onChange={() => {}}
                  onClick={(e) => e.stopPropagation()}
                  className="h-4 w-4"
                />
                <span>{status}</span>
              </label>
            </div>
          ))}
        </div>
      </div>

      {/* Criticality Filter Dropdown */}
      <div className="relative" style={{ minWidth: '220px' }}>
        <div
          className="p-2 border rounded flex justify-between items-center cursor-pointer bg-pink-50 text-pink-700"
          onClick={() => {
            const dropdown = document.getElementById('criticality-filter-dropdown');
            if (dropdown) {
              dropdown.style.display = dropdown.style.display === 'none' ? 'block' : 'none';
            }
          }}
        >
          <div className="flex items-center">
            <img src="/icons/noun-critical-status-7295245-FF824A.svg" alt="Criticality" className="w-6 h-6 mr-2" />
            <span className="text-xs truncate" style={{ maxWidth: '150px' }}>
              Criticality ({criticalityFilter.length})
            </span>
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>

        <div
          id="criticality-filter-dropdown"
          className="absolute left-0 right-0 mt-1 bg-white border rounded shadow-lg z-10"
          style={{ display: 'none', maxHeight: '250px', overflowY: 'auto' }}
        >
          <div className="p-2 border-b sticky top-0 bg-white">
            <div className="flex justify-between items-center">
              <button
                className="text-xs text-blue-600 hover:text-blue-800"
                onClick={(e) => {
                  e.stopPropagation();
                  setCriticalityFilter([...availableCriticalities]);
                }}
              >
                Select All
              </button>
              <button
                className="text-xs text-blue-600 hover:text-blue-800"
                onClick={(e) => {
                  e.stopPropagation();
                  setCriticalityFilter([]);
                }}
              >
                Clear All
              </button>
            </div>
          </div>

          {availableCriticalities.map(criticality => (
            <div
              key={criticality}
              className="p-2 hover:bg-gray-100 cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setCriticalityFilter(prev => {
                  if (prev.includes(criticality)) {
                    return prev.filter(c => c !== criticality);
                  } else {
                    return [...prev, criticality];
                  }
                });
              }}
            >
              <label className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={criticalityFilter.includes(criticality)}
                  onChange={() => {}}
                  onClick={(e) => e.stopPropagation()}
                  className="h-4 w-4"
                />
                <span>{criticality}</span>
              </label>
            </div>
          ))}
        </div>
      </div>

      {/* Priority Filter Dropdown */}
      <div className="relative" style={{ minWidth: '220px' }}>
        <div
          className="p-2 border rounded flex justify-between items-center cursor-pointer bg-blue-50 text-blue-700"
          onClick={() => {
            const dropdown = document.getElementById('priority-filter-dropdown');
            if (dropdown) {
              dropdown.style.display = dropdown.style.display === 'none' ? 'block' : 'none';
            }
          }}
        >
          <div className="flex items-center">
            <img src="/icons/noun-priority-7620160-FF824A.svg" alt="Priority" className="w-6 h-6 mr-2" />
            <span className="text-xs truncate" style={{ maxWidth: '150px' }}>
              Priority ({priorityFilter.length})
            </span>
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>

        <div
          id="priority-filter-dropdown"
          className="absolute left-0 right-0 mt-1 bg-white border rounded shadow-lg z-10"
          style={{ display: 'none', maxHeight: '250px', overflowY: 'auto' }}
        >
          <div className="p-2 border-b sticky top-0 bg-white">
            <div className="flex justify-between items-center">
              <button
                className="text-xs text-blue-600 hover:text-blue-800"
                onClick={(e) => {
                  e.stopPropagation();
                  setPriorityFilter([...availablePriorities]);
                }}
              >
                Select All
              </button>
              <button
                className="text-xs text-blue-600 hover:text-blue-800"
                onClick={(e) => {
                  e.stopPropagation();
                  setPriorityFilter([]);
                }}
              >
                Clear All
              </button>
            </div>
          </div>

          {availablePriorities.map(priority => (
            <div
              key={priority}
              className="p-2 hover:bg-gray-100 cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setPriorityFilter(prev => {
                  if (prev.includes(priority)) {
                    return prev.filter(p => p !== priority);
                  } else {
                    return [...prev, priority];
                  }
                });
              }}
            >
              <label className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={priorityFilter.includes(priority)}
                  onChange={() => {}}
                  onClick={(e) => e.stopPropagation()}
                  className="h-4 w-4"
                />
                <span>{priority}</span>
              </label>
            </div>
          ))}
        </div>
      </div>

      {/* Created Date range filter */}
      <DateRangePicker
        label={<span className="text-xs">Creation Date</span>}
        value={dateRangeFilter}
        onChange={setDateRangeFilter}
        icon={<Calendar size={20} />}
        color="green"
      />

      {/* Updated Date range filter */}
      <DateRangePicker
        label={<span className="text-xs">Last Updated</span>}
        value={updatedDateRangeFilter}
        onChange={setUpdatedDateRangeFilter}
        icon={<Calendar size={16} />}
        color="green"
      />

      {/* Applied filters count */}
      <div className="text-sm text-green-500">
        <button
          onClick={() => {
            setStatusFilter([]);
            setCriticalityFilter([]);
            setPriorityFilter([]);
            setDateRangeFilter({ startDate: '', endDate: '' });
            setUpdatedDateRangeFilter({ startDate: '', endDate: '' });
          }}
         className="ml-auto px-3 py-1 text-sm bg-red-300 text-white rounded hover:bg-red-500 flex items-center">
         <X size={18} className="mr-1" />
          Reset all filters
        </button>
        {statusFilter.length > 0 && `${statusFilter.length} status filters • `}
        {criticalityFilter.length > 0 && `${criticalityFilter.length} criticality filters • `}
        {priorityFilter.length > 0 && `${priorityFilter.length} priority filters • `}
        {(dateRangeFilter.startDate || dateRangeFilter.endDate) && 'Creation date filter applied • '}
        {(updatedDateRangeFilter.startDate || updatedDateRangeFilter.endDate) && 'Update date filter applied • '}
      </div>
    </div>
  </div>

)}
{/* END Collapsible filters content */}











</div>











          {/* Layout restructured here - main area and right sidebar with buttons */}
          <div className="flex gap-4">
            {/* Main table area - takes up most of the space */}
            <div className="flex-1">
              <div className="bg-white rounded-lg shadow">
                <table style={styles.table}>
                  <thead className="bg-gray-50 border-b">
                    <tr>
                      <th style={styles.th}>
                        <input
                          type="checkbox"
                          checked={requirements.length > 0 && selectedRequirements.size === requirements.length}
                          onChange={(e) => {
                            const newSelected = new Set();
                            if (e.target.checked) {
                              requirements.forEach(req => newSelected.add(req.req_id));
                            }
                            setSelectedRequirements(newSelected);
                          }}
                        />
                      </th>



                       {selectedProducts.length === 0 && (
                          <th style={styles.th} className="select-none">
                            <div className="flex items-center">
                              <span style={{  }}>*</span>
                            </div>
                          </th>
                        )}






                      <th
                        style={styles.th}
                        onClick={() => handleSort('req_id')}
                        className="select-none hover:bg-gray-200 transition-colors"
                      >
                        <div className="flex items-center">
                          <span style={{ textDecoration: 'underline' }}>ID</span>
                          <span className="ml-1">
                            {sortConfig.key === 'req_id' ? (
                              sortConfig.direction === 'asc' ? <SortAsc size={14} /> : <SortDesc size={14} />
                            ) : null}
                          </span>
                        </div>
                      </th>
                      <th
                        style={styles.th}
                        onClick={() => handleSort('level_description')}
                        className="select-none hover:bg-gray-200 transition-colors"
                      >
                        <div className="flex items-center">
                          <span style={{ textDecoration: 'underline' }}>Functional Level</span>
                          <span className="ml-1">
                            {sortConfig.key === 'level_description' ? (
                              sortConfig.direction === 'asc' ? <SortAsc size={14} /> : <SortDesc size={14} />
                            ) : null}
                          </span>
                        </div>
                      </th>
                      <th
                        style={styles.th}
                        onClick={() => handleSort('req_description')}
                        className="select-none hover:bg-gray-200 transition-colors"
                      >
                        <div className="flex items-center">
                          <span style={{ textDecoration: 'underline' }}>Description</span>
                          <span className="ml-1">
                            {sortConfig.key === 'req_description' ? (
                              sortConfig.direction === 'asc' ? <SortAsc size={14} /> : <SortDesc size={14} />
                            ) : null}
                          </span>
                        </div>
                      </th>
                      <th
                        style={styles.th}
                        onClick={() => handleSort('status')}
                        className="select-none hover:bg-gray-200 transition-colors"
                      >
                        <div className="flex items-center">
                          <span style={{ textDecoration: 'underline' }}>Status</span>
                          <span className="ml-1">
                            {sortConfig.key === 'status' ? (
                              sortConfig.direction === 'asc' ? <SortAsc size={14} /> : <SortDesc size={14} />
                            ) : null}
                          </span>
                        </div>
                      </th>


                        {selectedProducts.length === 0 && (

                      <th
                        style={styles.th}
                        onClick={() => handleSort('req_criticality')}
                        className="select-none hover:bg-gray-200 transition-colors"
                      >
                        <div className="flex items-center">
                          <span style={{ textDecoration: 'underline' }}>Criticality</span>
                          <span className="ml-1">
                            {sortConfig.key === 'req_criticality' ? (
                              sortConfig.direction === 'asc' ? <SortAsc size={14} /> : <SortDesc size={14} />
                            ) : null}
                          </span>
                        </div>
                      </th>
                        )}


                        {/* Priority column - only shown when no products are selected */}
                        {selectedProducts.length === 0 && (
                          <th
                            style={styles.th}
                            onClick={() => handleSort('req_priority')}
                            className="select-none hover:bg-gray-200 transition-colors"
                          >
                            <div className="flex items-center">
                              <span style={{ textDecoration: 'underline' }}>Priority</span>
                              <span className="ml-1">
                                {sortConfig.key === 'req_priority' ? (
                                  sortConfig.direction === 'asc' ? <SortAsc size={14} /> : <SortDesc size={14} />
                                ) : null}
                              </span>
                            </div>
                          </th>
                        )}




                        {/* Creation Date column - only shown when no products are selected */}
                        {selectedProducts.length === 0 && (
                          <th
                            style={styles.th}
                            onClick={() => handleSort('created_date')}
                            className="select-none hover:bg-gray-200 transition-colors"
                          >
                            <div className="flex items-center">
                              <span style={{ textDecoration: 'underline' }}>Creation Date</span>
                              <span className="ml-1">
                                {sortConfig.key === 'created_date' ? (
                                  sortConfig.direction === 'asc' ? <SortAsc size={14} /> : <SortDesc size={14} />
                                ) : null}
                              </span>
                            </div>
                          </th>
                        )}

                        {/* Last Updated column - only shown when no products are selected */}
                        {selectedProducts.length === 0 && (
                          <th
                            style={styles.th}
                            onClick={() => handleSort('updated_date')}
                            className="select-none hover:bg-gray-200 transition-colors"
                          >
                            <div className="flex items-center">
                              <span style={{ textDecoration: 'underline' }}>Last Updated</span>
                              <span className="ml-1">
                                {sortConfig.key === 'updated_date' ? (
                                  sortConfig.direction === 'asc' ? <SortAsc size={14} /> : <SortDesc size={14} />
                                ) : null}
                              </span>
                            </div>
                          </th>
                        )}
                    {/* Dynamic Product Classification Columns */}
                    {selectedProducts.map((product, index) => (
                      <th
                        key={product.product_id}
                        style={styles.th}
                        className="select-none bg-blue-50"
                      >
                        <div className="flex items-center">
                          <span style={{ textDecoration: 'underline' }}>{product.product_name}</span>
                        </div>
                      </th>
                    ))}


















                    </tr>
                  </thead>
                  <tbody>
                    {paginatedRequirements.map(requirement => (
                      <tr
                        key={requirement.req_id}
                        className="border-t hover:bg-gray-50"
                      >
                        <td className="px-4 py-3">
                          <input
                            type="checkbox"
                            checked={selectedRequirements.has(requirement.req_id)}
                            onChange={() => {
                              const newSelected = new Set(selectedRequirements);
                              if (newSelected.has(requirement.req_id)) {
                                newSelected.delete(requirement.req_id);
                              } else {
                                newSelected.add(requirement.req_id);
                              }
                              setSelectedRequirements(newSelected);
                            }}
                          />



                        </td>








                    {selectedProducts.length === 0 && (
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-1">
                          {/* Has Exceptions */}
                          {requirement.number_of_exceptions > 0 && (
                            <img
                              src="/icons/noun-exception-3535754-FF59B9.svg"
                              alt="Has Exceptions"
                              className="w-4 h-4"
                              title={`${requirement.number_of_exceptions} exception(s)`}
                            />
                          )}

                          {/* Has Approvers */}
                          {requirement.number_of_approvers > 0 && (
                            <img
                              src="/icons/noun-team-6990022-007435.svg"
                              alt="Has Approvers"
                              className="w-4 h-4"
                              title={`${requirement.number_of_approvers} approver(s)`}
                            />
                          )}

                          {/* Has Comments - placeholder for when API is updated */}
                           {requirement.number_of_comments > 0 && (
                            <img
                              src="/icons/noun-comments-6695629-FF824A.svg"
                              alt="Has Comments"
                              className="w-4 h-4"
                              title={`${requirement.number_of_comments} comment(s)`}
                            />
                          )}

                          {/* Has Links */}
                          {requirement.number_of_links > 0 && (
                            <img
                              src="/icons/noun-chain-6895019-FF824A.svg"
                              alt="Has Links"
                              className="w-4 h-4"
                              title={`${requirement.number_of_links} link(s)`}
                            />
                          )}

                          {/* Has Product Classification */}
                          {requirement.number_of_classifications > 0 && (
                            <img
                              src="/icons/noun-classification-6814016-4C25E1.svg"
                              alt="Has Product Classification"
                              className="w-4 h-4"
                              title={`${requirement.number_of_classifications} classification(s)`}
                            />
                          )}

                          {/* Has Use Cases  */}
                          {requirement.number_of_usecases > 0 && (
                            <img
                              src="/icons/noun-use-case-6308335-FF59B9.svg"
                              alt="Has Use Cases"
                              className="w-4 h-4"
                              title={`${requirement.number_of_usecases} use case(s)`}
                            />
                          )}

                          {/* Show placeholder if no attributes */}
                          {requirement.number_of_exceptions === 0 && requirement.number_of_approvers === 0
                           && requirement.number_of_comments === 0 && requirement.number_of_links === 0
                           && requirement.number_of_classifications === 0 && requirement.number_of_usecases === 0
                           && (
                            <span className="text-gray-400 text-xs">-</span>
                          )}
                        </div>
                      </td>
                    )}

















                               <td className="px-4 py-3">
                              <div className="relative group">
                                <button
                                  className="text-blue-600 hover:text-blue-800 hover:underline focus:outline-none"
                                  onClick={() => {
                                    setSelectedRequirements(new Set([requirement.req_id]));
                                    setSelectedRequirementForEdit(requirement);
                                    setIsEditMode(true);
                                    setIsCreateDialogOpen(true);
                                  }}
                                >
                                  {requirement.req_id_with_prefix}
                                </button>

                                {/* Keep tooltip for informational purposes */}
                                {!permissions.canUpdate && (
                                  <div className="absolute left-0 top-full mt-2 px-3 py-2 bg-gray-600 text-white text-xs rounded shadow-lg invisible group-hover:visible whitespace-nowrap z-20">
                                    Note: You have limited permission to edit requirements
                                    <div className="absolute bottom-full left-4 w-0 h-0 border-l-4 border-r-4 border-b-4 border-transparent border-b-gray-600"></div>
                                  </div>
                                )}
                              </div>
                            </td>













                        <td className="px-4 py-3">{requirement.level_description}</td>
                        <td className="px-4 py-3">{requirement.req_description}</td>
                        <td className="px-4 py-3">
                          <span className={`px-2 py-1 rounded-full text-xs ${
                            requirement.status === 'Approved' ? 'bg-green-100 text-green-800' :
                            'bg-white-100 text-gray-800'
                          }`}>
                            {requirement.status}
                          </span>
                        </td>




                        {selectedProducts.length === 0 && (
                          <td className="px-4 py-3">
                            {requirement.criticality_icon_url ? (
                              <img
                                src={requirement.criticality_icon_url}
                                alt={requirement.req_criticality || 'Criticality'}
                                title={requirement.req_criticality || 'Criticality'}
                                style={{
                                  width: '48px',
                                  height: '48px',
                                  objectFit: 'contain',
                                  cursor: 'pointer'
                                }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                }}
                              />
                            ) : (
                              <span className={`px-2 py-1 rounded-full text-xs`}>
                                {requirement.req_criticality}
                              </span>
                            )}
                          </td>
                        )}









                         {/* Priority cell - only shown when no products are selected */}
                        {selectedProducts.length === 0 && (
                          <td className="px-4 py-3">
                            {requirement.priority_icon_url ? (
                              <img
                                src={requirement.priority_icon_url}
                                alt={requirement.req_priority || 'Priority'}
                                title={requirement.req_priority || 'Priority'}
                                style={{
                                  width: '48px',
                                  height: '48px',
                                  objectFit: 'contain',
                                  cursor: 'pointer'
                                }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                }}
                              />
                            ) : (
                              <span className="text-xs">
                                {requirement.req_priority || 'Not set'}
                              </span>
                            )}
                          </td>
                        )}





















                        {/* Creation Date cell - only shown when no products are selected */}
                        {selectedProducts.length === 0 && (
                          <td className="px-4 py-3">
                            <span className="text-xs">
                              {requirement.created_date ? new Date(requirement.created_date).toLocaleDateString() : 'Not set'}
                            </span>
                          </td>
                        )}

                        {/* Last Updated cell - only shown when no products are selected */}
                        {selectedProducts.length === 0 && (
                          <td className="px-4 py-3">
                            <span className="text-xs">
                              {requirement.updated_date ? new Date(requirement.updated_date).toLocaleDateString() : 'Not set'}
                            </span>
                          </td>
                        )}



                        {/* Dynamic Product Classification Cells */}
                        {selectedProducts.map((product, index) => {
                          // Get the corresponding product classification based on index
                          const classificationKey = `product_${index + 1}_classification`;
                          const classification = requirement[classificationKey];
                          const hasEditAccess = productAccessLevels[product.product_id] === 5;

                            return (
                                <td key={`${requirement.req_id}-${product.product_id}`} className="px-4 py-3">
                                  {hasEditAccess ? (
                                    <select
                                      className="w-full text-xs p-1 border rounded bg-purple-100 text-purple-800 max-w-[150px]"
                                      value={classification?.product_classification || ''}
                                      onChange={(e) => updateRequirementClassification(
                                        requirement.req_id,
                                        product.product_id,
                                        e.target.value
                                      )}
                                      disabled={isUpdatingClassification}
                                    >
                                      <option value="">Select classification</option>
                                      {classificationOptions.map(option => (
                                        <option key={option} value={option}>
                                          {option}
                                        </option>
                                      ))}
                                    </select>
                                  ) : (
                                    classification && classification.product_classification ? (
                                      <span className="px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-800 max-w-[150px]">
                                        {classification.product_classification}
                                      </span>
                                    ) : (
                                      <span className="text-gray-400 text-xs">Not classified</span>
                                    )
                                  )}
                                </td>
                              );
                            })}




                      </tr>
                    ))}
                    {requirements.length === 0 && (
                      <tr>
                        <td colSpan="9" className="px-4 py-8 text-center text-gray-500">
                          No requirements found. {selectedLevelId ? 'Create a new requirement or adjust your search.' : 'Select a functional level to view requirements.'}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>



{/* Pagination and requirement count information - Updated to match RaidLogManagement style */}
{requirements.length > 0 && (
  <div className="mt-4 flex justify-between items-center bg-white p-4 rounded-lg shadow">
    <div className="flex items-center gap-2 text-sm text-gray-600">
      <span>Total Requirements: {requirements.length}</span>
      {selectedRequirements.size > 0 && (
        <span>| Selected: {selectedRequirements.size}</span>
      )}
      <span>| Showing {requirements.length > 0 ? startIndex + 1 : 0} - {Math.min(startIndex + itemsPerPage, requirements.length)} of {requirements.length}</span>
    </div>

    {/* Pagination controls with styled icons */}
    <div className="flex items-center gap-2">
      <button
        className="p-1 rounded hover:bg-gray-200 disabled:opacity-50"
        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
        disabled={currentPage === 1}
        aria-label="Previous page"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <span className="text-sm text-blue-600">Page {currentPage} of {Math.max(1, totalPages)}</span>
      <button
        className="p-1 rounded hover:bg-gray-200 disabled:opacity-50"
        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
        disabled={currentPage === totalPages || totalPages === 0}
        aria-label="Next page"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>

    {/* Items per page selector */}
    <div className="flex items-center">
      <span className="text-sm text-gray-600 mr-2">Items per page:</span>
      <select
        value={itemsPerPage}
        onChange={(e) => {
          setItemsPerPage(Number(e.target.value));
          setCurrentPage(1); // Reset to first page when changing items per page
        }}
        className="border rounded p-1 text-sm"
      >
        <option value={5}>5</option>
        <option value={10}>10</option>
        <option value={15}>15</option>
        <option value={20}>20</option>
        <option value={50}>50</option>
      </select>
    </div>
  </div>
)}




            </div>

            {/* Right sidebar with buttons and icons - No background colors */}
            <div className="w-64 bg-white border rounded shadow-sm" style={{
              position: 'sticky',
              top: '1.5rem',
              height: 'fit-content',
              maxHeight: 'calc(100vh - 9rem)',
              overflowY: 'auto'
            }}>
              <div className="p-4">
                <h3 className="font-bold text-sm text-orange-700 mb-4 bg-orange-200">REQUIREMENT ACTIONS</h3>

                {/* Status and Criticality buttons */}
                <div className="space-y-2 mb-6">
                  <button
                    className={`w-full px-3 py-2 rounded text-sm flex items-center ${
                      !permissions.canUpdateStatus || selectedRequirements.size === 0
                        ? 'text-gray-400'
                        : 'text-blue-700 hover:text-blue-900'
                    }`}
                    disabled={selectedRequirements.size === 0 || !permissions.canUpdateStatus}
                    onClick={() => setIsUpdateStatusDialogOpen(true)}
                  >
                    <img
                      src="/icons/noun-status-7577449-FF824A.svg"
                      alt="Update Status"
                      className={`w-8 h-8 mr-3 ${!permissions.canUpdateStatus || selectedRequirements.size === 0 ? 'opacity-50' : ''}`}
                    />


                    <span className={`flex items-center ${!permissions.canUpdateStatus || selectedRequirements.size === 0 ? 'text-orange-400' : 'text-orange-700'}`}>



                      Update Status


                          <img
                            src="/icons/noun-one-to-many-1406451-FF824A.svg"
                            alt="Info"
                            className="w-6 h-6 ml-2"
                          />


                    </span>
                  </button>




                  <button
                    className={`w-full px-3 py-2 rounded text-sm flex items-center ${
                      !permissions.canUpdatePriority || selectedRequirements.size === 0
                        ? 'text-gray-400'
                        : 'text-blue-700 hover:text-blue-900'
                    }`}
                    disabled={selectedRequirements.size === 0 || !permissions.canUpdatePriority}
                    onClick={() => setIsUpdatePriorityDialogOpen(true)}
                  >
                    <img
                      src="/icons/noun-priority-7620160-FF824A.svg"
                      alt="Update Priority"
                      className={`w-8 h-8 mr-3 ${!permissions.canUpdatePriority || selectedRequirements.size === 0 ? 'opacity-50' : ''}`}
                    />
                    <span className={`flex items-center ${!permissions.canUpdatePriority || selectedRequirements.size === 0 ? 'text-orange-400' : 'text-orange-700'}`}>

                      Update Priority
                        <img
                        src="/icons/noun-one-to-many-1406451-FF824A.svg"
                        alt="Info"
                        className="w-6 h-6 ml-2"
                      />
                    </span>
                  </button>


                  <button
                    className={`w-full px-3 py-2 rounded text-sm flex items-center ${
                      !permissions.canUpdateCriticality || selectedRequirements.size === 0
                        ? 'text-gray-400'
                        : 'text-blue-700 hover:text-blue-900'
                    }`}
                    disabled={selectedRequirements.size === 0 || !permissions.canUpdateCriticality}
                    onClick={() => setIsUpdateCriticalityDialogOpen(true)}
                  >
                    <img
                      src="/icons/noun-critical-status-7295245-FF824A.svg"
                      alt="Update Criticality"
                      className={`w-8 h-8 mr-3 ${!permissions.canUpdateCriticality || selectedRequirements.size === 0 ? 'opacity-50' : ''}`}
                    />
                    <span className={`flex items-center ${!permissions.canUpdateCriticality || selectedRequirements.size === 0 ? 'text-orange-400' : 'text-orange-700'}`}>

                      Update Criticality
                        <img
                        src="/icons/noun-one-to-many-1406451-FF824A.svg"
                        alt="Info"
                        className="w-6 h-6 ml-2"
                      />
                    </span>
                  </button>



                    <button
                    className={`w-full px-3 py-2 rounded text-sm flex items-center ${
                      selectedRequirements.size !== 1
                        ? 'text-gray-400'
                        : 'text-blue-700 hover:text-blue-900'
                    }`}
                    disabled={!permissions.canCopy || selectedRequirements.size !== 1}
                    onClick={handleCopyButtonClick}
                  >
                    <img
                      src="/icons/noun-copy-7721290-FF824A.svg"
                      alt="Copy Requirement"
                      className={`w-8 h-8 mr-3 ${!permissions.canCopy || selectedRequirements.size !== 1 ? 'opacity-50' : ''}`}
                    />
                    <span className={!permissions.canCopy || selectedRequirements.size !== 1 ? 'text-orange-400' : 'text-orange-700'}>
                      Copy Requirement
                    </span>
                  </button>


                  <button
                    className={`w-full px-3 py-2 rounded text-sm flex items-center ${
                        selectedRequirements.size > 100
                        ? 'text-gray-400'
                        : 'text-blue-700 hover:text-blue-900'
                    }`}
                    disabled={  selectedRequirements.size > 100}
                    onClick={handleManageCommentsClick}
                  >
                    <img
                      src="/icons/noun-comments-6695629-FF824A.svg"
                      alt="Manage Comments"
                      className={`w-8 h-8 mr-3 ${ selectedRequirements.size > 100 ? 'opacity-50' : ''}`}
                    />
                    <span className={  selectedRequirements.size > 100 ? 'text-orange-400' : 'text-orange-700'}>
                      Manage Comments
                    </span>
                  </button>

                  <button
                    className={`w-full px-3 py-2 rounded text-sm flex items-center ${
                      selectedRequirements.size !== 1
                        ? 'text-gray-400'
                        : 'text-blue-700 hover:text-blue-900'
                    }`}
                    disabled={selectedRequirements.size !== 1 }
                    onClick={handleManageLinksClick}
                  >
                    <img
                      src="/icons/noun-chain-6895019-FF824A.svg"
                      alt="Manage Links"
                      className={`w-8 h-8 mr-3 ${selectedRequirements.size !== 1    ? 'opacity-50' : ''}`}
                    />
                    <span className={selectedRequirements.size !== 1 ? 'text-orange-400' : 'text-orange-700'}>
                      Manage Links
                    </span>
                  </button>
                </div>


           {/* Exception management */}
                <h4 className="font-bold text-xs text-pink-600 bg-pink-200 mb-2">EXCEPTIONS</h4>
                <div className="space-y-2 mb-6">
                  <button
                    className={`w-full px-3 py-2 rounded text-sm flex items-center ${
                      (!selectedLevelId && selectedRequirements.size === 0)
                        ? 'text-gray-400'
                        : 'text-blue-700 hover:text-blue-900'
                    }`}
                    disabled={(!selectedLevelId && selectedRequirements.size === 0) || !permissions.canCreateException}
                    onClick={() => setIsCreateExceptionDialogOpen(true)}
                  >
                    <img
                      src="/icons/noun-create-5110874-FF59B9.svg"
                      alt="Create Exception"
                      className={`w-8 h-8 mr-3 ${(!selectedLevelId && selectedRequirements.size === 0) || !permissions.canCreateException  ? 'opacity-50' : ''}`}
                    />


                    <span className={`flex items-center ${(!selectedLevelId && selectedRequirements.size === 0) || !permissions.canCreateException ? 'text-pink-400' : 'text-pink-700'}`}>

                      Create Exception


                                <img
                                src="/icons/noun-one-to-many-1406451-FF59B9.svg"
                                alt="Info"
                                className="w-6 h-6 ml-2"
                              />



                    </span>
                  </button>

                  <button
                    className={`w-full px-3 py-2 rounded text-sm flex items-center ${
                      selectedRequirements.size > 1
                        ? 'text-gray-400'
                        : 'text-blue-700 hover:text-blue-900'
                    }`}
                    disabled={selectedRequirements.size > 1   }
                    onClick={() => {
                      setExceptionLevel('Requirement');
                      setIsKeyAttributesDialogOpen(true);
                    }}
                  >
                    <img
                      src="/icons/noun-exception-3535754-FF59B9.svg"
                      alt="Manage Exceptions"
                      className={`w-10 h-10 mr-3 ${selectedRequirements.size > 1   ? 'opacity-50' : ''}`}
                    />
                    <span className={selectedRequirements.size > 1  ? 'text-pink-400' : 'text-pink-700'}>
                      Manage Exceptions
                    </span>
                  </button>
                </div>


                {/* Classification management */}
                <h4 className="font-bold text-xs text-purple-600 bg-purple-200 mb-2">PRODUCT CLASSIFICATION</h4>
                <div className="space-y-2 mb-6">
                          <button
                      className={`w-full px-3 py-2 rounded text-sm flex items-center ${
                        (!selectedLevelId && selectedRequirements.size === 0) || !permissions.canUpdateClassification || selectedRequirements.size === 0
                          ? 'text-gray-400'
                          : 'text-blue-700 hover:text-blue-900'
                      }`}
                      disabled={(!selectedLevelId && selectedRequirements.size === 0) || !permissions.canUpdateClassification || selectedRequirements.size === 0}
                      onClick={() => setIsClassificationDialogOpen(true)}
                    >
                      <img
                        src="/icons/noun-classification-6814016-4C25E1.svg"
                        alt="Update Classification"
                        className={`w-8 h-8 mr-3 ${(!selectedLevelId && selectedRequirements.size === 0) || !permissions.canUpdateClassification || selectedRequirements.size === 0 ? 'opacity-50' : ''}`}
                      />

                      <span className={`flex items-center ${(!selectedLevelId && selectedRequirements.size === 0) || !permissions.canUpdateClassification || selectedRequirements.size === 0 ? 'text-purple-400' : 'text-purple-700'}`}>
                        Update Classification
                        <img
                          src="/icons/noun-one-to-many-1406451-4C25E1.svg"
                          alt="Info"
                          className="w-6 h-6 ml-2"
                        />
                      </span>
                    </button>


                </div>

                {/* Approval management */}
                <h4 className="font-bold text-xs text-green-600 bg-green-200 mb-2">APPROVALS</h4>
                <div className="space-y-2 mb-6">
                  <button
                         className={`w-full px-3 py-2 rounded text-sm flex items-center text-green-700 hover:text-green-900 `}
                    onClick={handleManageApproversClick}
                  >
                    <img
                      src="/icons/noun-team-6990022-007435.svg"
                      alt="Manage Approvers"
                     className={`w-8 h-8 mr-3 `}

                    />
                      <span className={`flex items-center `}>
                            Manage Approvers

                    </span>
                  </button>



                <button
                  className={`w-full px-3 py-2 rounded text-sm flex items-center ${
                    selectedRequirements.size === 0
                      ? 'text-gray-400'
                      : 'text-green-700 hover:text-green-900'
                  }`}
                  disabled={selectedRequirements.size === 0}
                  onClick={() => setIsAddApproverDialogOpen(true)}
                >
                  <img
                    src="/icons/noun-add-user-301304-007435.svg"
                    alt="Add Approver"
                    className={`w-10 h-10 mr-3 ${selectedRequirements.size === 0 ? 'opacity-50' : ''}`}
                  />
                  <span className={`flex items-center ${selectedRequirements.size === 0 ? 'text-green-500' : 'text-green-700'}`}>
                    Add Approver
                    <img
                      src="/icons/noun-one-to-many-1406451-007435.svg"
                      alt="Info"
                      className="w-6 h-6 ml-2"
                    />
                  </span>
                </button>








                  <button
                         className={`w-full px-3 py-2 rounded text-sm flex items-center text-green-700 hover:text-green-900 ${
                         !permissions.canApprove  ? 'text-gray-400': 'text-green-700 hover:text-green-900'
                      }`}
                    disabled={ !permissions.canApprove}
                      onClick={handleApproveButtonClick}
                  >
                    <img
                      src="/icons/noun-endorse-6109251-007435.svg"
                      alt="Approve"
                     className={`w-8 h-8 mr-3 ${  !permissions.canApprove  ? 'opacity-50' : ''}`}
                    />
                      <span className={`flex items-center ${  !permissions.canApprove ? 'text-green-500' : 'text-green-700'}`}>
                    Approve


                              <img
                                src="/icons/noun-one-to-many-1406451-007435.svg"
                                alt="Info"
                                className="w-6 h-6 ml-2"
                              />



                    </span>
                  </button>
                </div>




                {/* Testing components */}
                <h4 className="font-bold text-xs text-pink-600 bg-pink-200 mb-2">TESTING</h4>
                <div className="space-y-2 mb-6">
                  <button
                    className={`w-full px-3 py-2 rounded text-sm flex items-center ${
                      selectedRequirements.size > 1
                        ? 'text-gray-400'
                        : 'text-blue-700 hover:text-blue-900'
                    }`}
                    disabled={ selectedRequirements.size > 1}
                    onClick={handleManageUseCasesClick}
                  >
                    <img
                      src="/icons/noun-use-case-6308335-FF59B9.svg"
                      alt="Manage Use Cases"
                      className={`w-8 h-8 mr-3 ${selectedRequirements.size > 1 ? 'opacity-50' : ''}`}
                    />
                    <span className={selectedRequirements.size > 1 ? 'text-pink-400' : 'text-pink-600'}>
                      Manage Use Cases
                    </span>
                  </button>
                </div>


          {/* Export components */}
                <h4 className="font-bold text-xs text-purple-600 bg-purple-200 mb-2">MISCELLANEOUS</h4>
                <div className="space-y-2 mb-6">
                  <button
                    className={`w-full px-3 py-2 rounded text-sm flex items-center`}
                    disabled={ requirements.length === 0}
                    onClick={handleExportToCSV}
                  >
                    <img
                      src="/icons/noun-csv-6903298-C462DD.svg"
                      alt="Export to CSV"
                      className={`w-8 h-8 mr-3 ${requirements.length === 0 ? 'opacity-50' : ''}`}
                    />
                    <span className={requirements.length === 0? 'text-purple-400' : 'text-purple-600'}>
                      Export To CSV
                    </span>
                  </button>
                </div>






                    <div className="flex items-center text-xs text-gray-500 italic mt-4">

                                                    <img
                                                src="/icons/noun-one-to-many-1406451-676767.svg"
                                                alt="Info"
                                                className="w-6 h-6 ml-2"
                                              />
                       -Supports multiple row selection
                    </div>

              </div>
            </div>

          </div>
        </div>
      </div>

      {/* All dialog components remain unchanged */}
      {showDialog && (
        <Dialog
            message={dialogMessage}
          onClose={() => {
            setShowDialog(false);
            if (dialogMessage.includes('successfully')) {
              console.log(`inside showDialog`);
            }
          }}
          onCancel={() => setShowDialog(false)}
        />
      )}







<UpdateStatusDialog
  isOpen={isUpdateStatusDialogOpen}
  onClose={() => setIsUpdateStatusDialogOpen(false)}
  onSubmit={handleUpdateStatus}
  selectedIds={Array.from(selectedRequirements)}
  availableStatuses={availableStatuses}
/>

<UpdateCriticalityDialog
  isOpen={isUpdateCriticalityDialogOpen}
  onClose={() => setIsUpdateCriticalityDialogOpen(false)}
  onSubmit={handleUpdateCriticality}
  selectedIds={Array.from(selectedRequirements)}
  availableCriticalities={availableCriticalities}
/>

<UpdatePriorityDialog
  isOpen={isUpdatePriorityDialogOpen}
  onClose={() => setIsUpdatePriorityDialogOpen(false)}
  onSubmit={handleUpdatePriority}
  selectedIds={Array.from(selectedRequirements)}
  availablePriorities={availablePriorities}
/>



                            <ManageRequirementExceptions
                              isOpen={isKeyAttributesDialogOpen}
                              onClose={() => setIsKeyAttributesDialogOpen(false)}
                              selectedIds={Array.from(selectedRequirements)}
                              corporateAccount={corporateAccount}
                              currentProject={currentProject}
                              selectedLevelId={selectedLevelId}
                              login_token={login_token}
                              canDeleteException={permissions.canDeleteException}
                              functionalLevelDescription={getCurrentFunctionalLevelDescription()}
                              requirementIdWithPrefix={getSelectedRequirementIdWithPrefix()}
                              selectedRequirements={selectedRequirements}

                             />





                        <UpdateClassificationDialog
                          isOpen={isClassificationDialogOpen}
                          onClose={(success) => {
                            setIsClassificationDialogOpen(false);
                            if (success) {
//                              setDialogMessage('Classification updated successfully');
//                              setShowDialog(true);
                              // Add this line to refresh the requirements after classification update
                              fetchRequirements(selectedLevelId);
                            }
                          }}
                          selectedRequirements={selectedRequirements}
                          corporateAccount={corporateAccount}
                          currentProject={currentProject}
                          login_token={login_token}
                          userId={userId}
                          requirementIdWithPrefix={getSelectedRequirementIdWithPrefix()}
                        />


                            <CreateExceptionDialog
                              isOpen={isCreateExceptionDialogOpen}
                              onClose={(success) => {
                                setIsCreateExceptionDialogOpen(false);
                                if (success) {
                                  // If you need to perform any actions after successful creation
//                                  setDialogMessage('Exception created successfully');
//                                  setShowDialog(true);
                                  // Refresh data if needed
                                }
                              }}
                              selectedRequirements={selectedRequirements}
                              selectedLevelId={selectedLevelId}
                              corporateAccount={corporateAccount}
                              currentProject={currentProject}
                              login_token={login_token}
                              functionalLevelDescription={getCurrentFunctionalLevelDescription()}
                              requirementIdWithPrefix={getSelectedRequirementIdWithPrefix()}
                            />



                            <CopyRequirementDialog
                              isOpen={isCopyDialogOpen}
                              onClose={(success) => {
                                setIsCopyDialogOpen(false);
                                if (success) {
                                  // Refresh the requirements list after successful copy
                                  fetchRequirements(selectedLevelId);
                                  setSelectedRequirements(new Set());
                                }
                              }}
                              requirementToCopy={selectedRequirementForCopy}
                              corporateAccount={corporateAccount}
                              currentProject={currentProject}
                              login_token={login_token}
                            />


                            <ManageApproversDialog
                              isOpen={isManageApproversDialogOpen}
                              onClose={() => setIsManageApproversDialogOpen(false)}
                              selectedRequirements={selectedRequirements}
                              selectedLevelId={selectedLevelId}
                              corporateAccount={corporateAccount}
                              currentProject={currentProject}
                              directLinkPath={'/BaseRequirementsManagement'}
                              login_token={login_token}
                              functionalLevelDescription={getCurrentFunctionalLevelDescription()}
                              requirementIdWithPrefix={getSelectedRequirementIdWithPrefix()}
                                req_type={(() => {
                                // Priority logic: Requirement > Functional > Project
                                if (selectedRequirements && selectedRequirements.size > 0) {
                                  // If requirements are selected, this is requirement level approval
                                  return "REQUIREMENT";
                                } else if (selectedLevelId) {
                                  // If a functional level is selected but no requirements, this is functional level approval
                                  return "FUNCTIONAL LEVEL";
                                } else {
                                  // If neither requirements nor functional level selected, this is project level approval
                                  return "PROJECT LEVEL";
                                }
                              })()}

                            />



                <ApproveRequirementsDialog
                  isOpen={isApprovalDialogOpen}
                  onClose={(success, refreshOnly = false) => {
                    // If refreshOnly is true, just refresh the list but keep dialog open
                    if (refreshOnly) {
                      if (success) {
                        // Refresh the requirements list but don't close the dialog
                        fetchRequirements(selectedLevelId);
                        setSelectedRequirements(new Set());
                      }
                      return; // Don't close the dialog
                    }

                    // Normal close behavior
                    setIsApprovalDialogOpen(false);
                    if (success) {
                      // Refresh the requirements list after successful approval changes
                      fetchRequirements(selectedLevelId);
                      setSelectedRequirements(new Set());
//                      setDialogMessage('Approval status updated successfully');
//                      setShowDialog(true);
                    }
                  }}
                  selectedRequirements={selectedRequirements}
                  selectedLevelId={selectedLevelId}
                  corporateAccount={corporateAccount}
                  currentProject={currentProject}
                  login_token={login_token}
                  canEdit={permissions.canApprove}
                  functionalLevelDescription={getCurrentFunctionalLevelDescription()}
                  requirementIdWithPrefix={getSelectedRequirementIdWithPrefix()}
                  //req_type="REQUIREMENT" // Note: Use "REQUIREMENT" instead of "INTEGRATION"
                    req_type={(() => {
                    // Priority logic: Requirement > Functional > Project
                    if (selectedRequirements && selectedRequirements.size > 0) {
                      // If requirements are selected, this is requirement level approval
                      return "REQUIREMENT";
                    } else if (selectedLevelId) {
                      // If a functional level is selected but no requirements, this is functional level approval
                      return "FUNCTIONAL LEVEL";
                    } else {
                      // If neither requirements nor functional level selected, this is project level approval
                      return "PROJECT LEVEL";
                    }
                  })()}



                />




                            <ManageUseCasesDialog
                              isOpen={isManageUseCasesDialogOpen}
                              onClose={() => setIsManageUseCasesDialogOpen(false)}
                              selectedRequirements={selectedRequirements}
                              selectedLevelId={selectedLevelId}
                              corporateAccount={corporateAccount}
                              currentProject={currentProject}
                              login_token={login_token}
                              canEdit={permissions.canManageUseCases}
                              functionalLevelDescription={getCurrentFunctionalLevelDescription()}
                              requirementIdWithPrefix={getSelectedRequirementIdWithPrefix()}
                            />



                            <ManageCommentsDialog
                              isOpen={isManageCommentsDialogOpen}
                              onClose={() => setIsManageCommentsDialogOpen(false)}
                              selectedRequirements={selectedRequirements}
                              selectedLevelId={selectedLevelId}
                              corporateAccount={corporateAccount}
                              currentProject={currentProject}
                              login_token={login_token}
                              functionalLevelDescription={getCurrentFunctionalLevelDescription()}
                              requirementIdWithPrefix={getSelectedRequirementIdWithPrefix()}
                            />



                            <ManageLinksDialog
                              isOpen={isManageLinksDialogOpen}
                              onClose={() => setIsManageLinksDialogOpen(false)}
                              corporateAccount={corporateAccount}
                              projectId={currentProject}
                              login_token={login_token}
                              functionalLevelDescription={getCurrentFunctionalLevelDescription()}
                              sourceRecordType='REQUIREMENT'
                              selectedSourceIds={selectedRequirements}
                              sourceIdWithPrefix={getSelectedRequirementIdWithPrefix()}
                            />





                <AddApproverDialog
                  isOpen={isAddApproverDialogOpen}
                  onClose={(success) => {
                    setIsAddApproverDialogOpen(false);
                    if (success) {
                      // Refresh the requirements list after successful addition
                      fetchRequirements(selectedLevelId);
                      setSelectedRequirements(new Set());
                    }
                  }}
                  selectedRequirements={selectedRequirements}
                  selectedLevelId={selectedLevelId}
                  corporateAccount={corporateAccount}
                  currentProject={currentProject}
                  directLinkPath={'/BaseRequirementsManagement'}
                  login_token={login_token}
                  functionalLevelDescription={getCurrentFunctionalLevelDescription()}
                  requirements={requirements}
                  req_type={(() => {
                    // Priority logic: Requirement > Functional > Project
                    if (selectedRequirements && selectedRequirements.size > 0) {
                      return "REQUIREMENT";
                    } else if (selectedLevelId) {
                      return "FUNCTIONAL LEVEL";
                    } else {
                      return "PROJECT LEVEL";
                    }
                  })()}
                />




                              <CreateRequirementDialog
                          isOpen={isCreateDialogOpen}
                          onClose={() => {
                            setIsCreateDialogOpen(false);
                            setIsEditMode(false);
                            setSelectedRequirementForEdit(null);
                          }}
                          onSubmit={() => {
                            fetchRequirements(selectedLevelId);
                            setSelectedRequirements(new Set());
                          }}
                          levelId={isEditMode && selectedRequirementForEdit
                            ? selectedRequirementForEdit.level_id
                            : selectedLevelId}
                          isEditMode={isEditMode}
                          requirementToEdit={selectedRequirementForEdit}
                          currentProject={currentProject}
                          corporateAccount={corporateAccount}
                          reqIdFromUrl={reqIdFromUrl}
                          login_token={login_token}
                          availableStatuses={availableStatuses}
                          availableCriticalities={availableCriticalities}
                          availablePriorities={availablePriorities}
                          permissions={permissions}
                          functionalLevelPath={
                            isEditMode && selectedRequirementForEdit
                              ? selectedRequirementForEdit.level_description
                              : selectedLevelId && functionalLevelPath.length > 0
                                ? functionalLevelPath[functionalLevelPath.length - 1].level_description
                                : 'Please select a functional level'
                          }
                          onOpenManageApprovers={(reqIdWithPrefix) => {
                            try {
                              console.log('Opening manage approvers for:', reqIdWithPrefix);

                              // Find the requirement and set it as selected
                              const requirement = requirements.find(req => req.req_id_with_prefix === reqIdWithPrefix);

                              if (requirement) {
                                console.log('Found requirement:', requirement);

                                // Set the selected requirement
                                setSelectedRequirements(new Set([requirement.req_id]));

                                // Close the create dialog first
                                setIsCreateDialogOpen(false);
                                setIsEditMode(false);
                                setSelectedRequirementForEdit(null);

                                // Small delay to ensure dialog closes properly before opening new one
                                setTimeout(() => {
                                  setIsManageApproversDialogOpen(true);
                                }, 100);
                              } else {
                                console.error('Requirement not found with ID:', reqIdWithPrefix);
                                setDialogMessage('Could not find the requirement to manage approvers');
                                setShowDialog(true);
                              }
                            } catch (error) {
                              console.error('Error opening manage approvers:', error);
                              setDialogMessage('Error opening manage approvers dialog');
                              setShowDialog(true);
                            }
                          }}
                        />



                        <AIRequirementsDialog
                          isOpen={isAIDialogOpen}
                          onClose={() => setIsAIDialogOpen(false)}
                          onCreateRequirements={handleCreateAIRequirements}
                          levelId={selectedLevelId}
                          functionalLevelPath={
                            selectedLevelId && functionalLevelPath.length > 0
                              ? functionalLevelPath[functionalLevelPath.length - 1].level_description
                              : 'Please select a functional level'
                          }
                          corporateAccount={corporateAccount}
                          currentProject={currentProject}
                          login_token={login_token}
                          availableStatuses={availableStatuses}
                          availableCriticalities={availableCriticalities}
                          availablePriorities={availablePriorities}
                        />





    </div>
  );
};

export default BaseRequirementsManagement;